/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      companyName
      annualIncome
      numberEmployees
      businessType
      companyLogo
      companyWebpage
      superAdminID
      mainCountryID
      superAdmin {
        id
        name
        familyName
        email
        phoneNumber
        role
        status
        color
        isConnected
        companyID
        createdAt
        updatedAt
      }

      countries {
        items {
          id
          companyEntityName
          companyIdentificationNumber
          companyAddress
          companyCity
          companyPostalCode
          companyPhoneNumber
          receiptPrefix
          receiptInitNumber
          receiptObservations
          kitchenReceipt
          posDiscountsSetting
          taxType
          customerUniqueID
          activeTips
          optionsTips
          electronicBilling
          invoiceAutomatic
          invoiceAutomaticPayments
          electronicBillingTokenCO
          electronicBillingTestIDCO
          secretBalanceSetting
          orderWithoutInventory
          outOfStockSellingRule
          country {
            id
            name
            currency
            phonePrefix
            currencyDecimal
            code
          }
        }
      }
      billing {
        items {
          id
          finalPrice
          currency
          startDate
          endDate
          companyID
          planID
          plan {
            id
            countryID
            name
            monthlyPrice
            currency
            tax
            users
            locations
            variants
            revenue
            periods
            published
            createdAt
            updatedAt
          }
          active
          trial
          paymentReceived
          codeID
          planDiscount
          countryID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCompanies = /* GraphQL */ `
  query ListCompanies(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyName
        annualIncome
        numberEmployees
        businessType
        companyLogo
        companyWebpage
        superAdminID
        superAdmin {
          id
          name
          familyName
          email
          phoneNumber
          role
          status
          color
          isConnected
          companyID
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      name
      familyName
      email
      phoneNumber
      role
      status
      color
      isConnected
      companyID
      company {
        companyName
        isNew
        mainCountry {
          id
          name
          language
          currency
          currencyDecimal
          code
          phonePrefix
        }
      }
      locations {
        items {
          id
          companyID
          locationID
          location {
            id
            name
            realName
            address
            countryID
            city {
              name
              timeZone
            }
            cashiers {
              items {
                id
                name
                mainPrint
                secondaryPrint
              }
            }
          }
          userID
          createdAt
          updatedAt
        }
        nextToken
      }
      userRolePermissions {
        items {
          id
          role {
            id
            roleName
            permissions
            isCustom
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        familyName
        email
        phoneNumber
        role
        status
        color
        isConnected
        connectedStore
        companyID
        company {
          companyName
          mainCountry {
            id
            name
            language
            currency
            phonePrefix
          }
        }
        variants {
          items {
            id
            variantID
            userID
          }
        }
        locations {
          items {
            id
            companyID
            locationID
            location {
              id
              name
              address
              countryID
              city {
                name
              }
              cashiers {
                items {
                  id
                  name
                }
              }
            }
            userID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const usersByCountryID = /* GraphQL */ `
  query UsersByCountryID(
    $countryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByCountryID(
      countryID: $countryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        familyName
        email
        phoneNumber
        role
        status
        color
        isConnected
        connectedStore
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          createdAt
          updatedAt
          mainCountry {
            id
            name
            language
            currency
            phonePrefix
          }
        }
        variants {
          items {
            id
            variantID
            userID
          }
        }
        locations {
          items {
            id
            companyID
            locationID
            location {
              id
              name
              address
              countryID
              city {
                name
              }
              cashiers {
                items {
                  id
                  name
                }
              }
            }
            userID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const usersByCompanyIDAndRole = /* GraphQL */ `
  query UsersByCompanyIDAndRole(
    $companyID: ID!
    $role: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByCompanyIDAndRole(
      companyID: $companyID
      role: $role
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        familyName
        email
        phoneNumber
        role
        status
        color
        isConnected
        connectedStore
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          createdAt
          updatedAt
          mainCountry {
            id
            name
            language
            currency
            phonePrefix
          }
        }
        variants {
          items {
            id
            variantID
            userID
          }
        }
        locations {
          items {
            id
            companyID
            locationID
            location {
              id
              name
              address
              countryID
              city {
                name
              }
              cashiers {
                items {
                  id
                  name
                }
              }
            }
            userID
            createdAt
            updatedAt
          }
          nextToken
        }
        userRolePermissions {
          items {
            id
            role {
              id
              roleName
              permissions
              createdAt
            }
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getLocation = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      name
      realName
      locationType
      country
      city {
        id
        lat
        long
        name
        timeZone
      }
      address
      postalCode
      lon
      lat
      active
      inStore
      pickCollect
      deliveries
      img
      companyID
      company {
        id
        companyName
        annualIncome
        numberEmployees
        businessType
        superAdminID
        superAdmin {
          id
          name
          familyName
          email
          phoneNumber
          role
          status
          color
          isConnected
          companyID
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      users {
        items {
          id
          user {
            id
            email
            name
            familyName
          }
        }
      }
      taxes {
        items {
          tax {
            id
            name
            percentage
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        locationType
        country
        city {
          id
          lat
          long
          name
          timeZone
        }
        address
        postalCode
        lon
        lat
        active
        inStore
        pickCollect
        deliveries
        img
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        users {
          items {
            user {
              id
              name
              familyName
              email
            }
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const locationsByCompanyIDAndCity = /* GraphQL */ `
  query LocationsByCompanyIDAndCity(
    $companyID: ID!
    $city: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationsByCompanyIDAndCity(
      companyID: $companyID
      city: $city
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        realName
        locationType
        country
        city
        address
        postalCode
        lon
        lat
        active
        inStore
        pickCollect
        deliveries
        img
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCountry = /* GraphQL */ `
  query GetCountry($id: ID!) {
    getCountry(id: $id) {
      id
      name
      language
      currency
      currencyDecimal
      code
      phonePrefix
      cities {
        items {
          id
          countryID
          name
          timeZone
          state
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

export const treasuryAccountsByCompanyID = `
  query TreasuryAccountsByCompanyID($companyID: ID!) {
    treasuryAccountsByCompanyID(companyID: $companyID) {
      items {
        id
        name
        type
        numberAccount
        balance
        currency
        description
        companyID
        countryID
        createdAt
        updatedAt
        accountingAccountID
        isAutomatic
        isMain
        transactions {
          items {
            id
            amount
            movementType
            finalBalance
            companyID
            createdAt
            updatedAt
            treasuryAccountID
          }
        }
      }
      nextToken
    }
  }
`;

export const listCountries = /* GraphQL */ `
  query ListCountries(
    $filter: ModelCountryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCountries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        language
        currency
        code
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCity = /* GraphQL */ `
  query GetCity($id: ID!) {
    getCity(id: $id) {
      id
      countryID
      name
      timeZone
      state
      country {
        id
        name
        language
        currency
        phonePrefix
        companies {
          nextToken
        }
        cities {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCities = /* GraphQL */ `
  query ListCities(
    $filter: ModelCityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        countryID
        name
        timeZone
        state
        country {
          id
          name
          language
          currency
          phonePrefix
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const citiesByCountryIDAndName = /* GraphQL */ `
  query CitiesByCountryIDAndName(
    $countryID: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    citiesByCountryIDAndName(
      countryID: $countryID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        countryID
        name
        timeZone
        state
        lat
        long
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCompanyCountry = /* GraphQL */ `
  query GetCompanyCountry($id: ID!) {
    getCompanyCountry(id: $id) {
      id
      companyID
      company {
        id
        companyName
        annualIncome
        numberEmployees
        businessType
        companyLogo
        companyWebpage
        phoneNumber
        mainEmail
        mainName
        superAdminID
        mainCountryID
        isNew
        saleObjective
        crmID
        createdAt
        updatedAt
        __typename
      }
      countryID
      country {
        id
        name
        language
        currency
        currencyDecimal
        code
        phonePrefix
        createdAt
        updatedAt
        __typename
      }
      companyEntityName
      companyIdentificationNumber
      companyAddress
      companyCity
      companyPostalCode
      companyPhoneNumber
      receiptPrefix
      receiptInitNumber
      electronicBilling
      electronicBillingTokenCO
      electronicBillingTestIDCO
      receiptObservations
      taxType
      customerUniqueID
      invoiceAutomatic
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const listCompanyCountries = /* GraphQL */ `
  query ListCompanyCountries(
    $filter: ModelCompanyCountryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanyCountries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        countryId
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        country {
          id
          name
          language
          currency
          phonePrefix
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const companyCountriesByCompanyID = /* GraphQL */ `
  query CompanyCountriesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyCountryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companyCountriesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        company {
          companyLogo
        }
        countryID
        companyEntityName
        companyIdentificationNumber
        companyAddress
        companyCity
        companyPostalCode
        companyPhoneNumber
        receiptInitNumber
        receiptPrefix
        receiptObservations
        kitchenReceipt
        taxType
        customerUniqueID
        currentVariants
        currentLocations
        currentUsers
        electronicBilling
        invoiceAutomatic
        invoiceAutomaticPayments
        activeTips
        optionsTips
        secretBalanceSetting
        orderWithoutInventory
        outOfStockSellingRule
        giftCardOptions
        giftCardType
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const companyCountriesByCountryId = /* GraphQL */ `
  query CompanyCountriesByCountryId(
    $countryId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyCountryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companyCountriesByCountryId(
      countryId: $countryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        countryId
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        country {
          id
          name
          language
          currency
          phonePrefix
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserLocation = /* GraphQL */ `
  query GetUserLocation($id: ID!) {
    getUserLocation(id: $id) {
      id
      userID
      locationID
      user {
        id
        name
        familyName
        email
        phoneNumber
        role
        status
        color
        isConnected
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        locations {
          nextToken
        }
        createdAt
        updatedAt
      }
      location {
        id
        name
        locationType
        country
        city
        address
        postalCode
        lon
        lat
        active
        inStore
        pickCollect
        deliveries
        img
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listUserLocations = /* GraphQL */ `
  query ListUserLocations(
    $filter: ModelUserLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        locationId
        user {
          id
          name
          familyName
          email
          phoneNumber
          role
          status
          color
          isConnected
          companyID
          createdAt
          updatedAt
        }
        location {
          id
          name
          locationType
          country
          city
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const userLocationsByUserIDAndCompanyID = /* GraphQL */ `
  query UserLocationsByUserIDAndCompanyID(
    $userID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userLocationsByUserIDAndCompanyID(
      userID: $userID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        locationID
        userID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const userLocationsByLocationIDAndCompanyID = /* GraphQL */ `
  query UserLocationsByLocationIDAndCompanyID(
    $locationID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userLocationsByLocationIDAndCompanyID(
      locationID: $locationID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        locationID
        userID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        name
        categoryID
        img
        color
        units
        description
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        variants {
          items {
            id
            name
            productName
            img
            sku
            barcode
            taxes {
              items {
                tax {
                  id
                  name
                  percentage
                }
              }
            }
          }
        }
        attributes {
          items {
            id
            name
            options
            order
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      type
      name
      realName
      categoryID
      category {
        name
      }
      img
      color
      units
      description
      companyID
      isPerishable
      customProperty {
        items {
          id
          customPropertyID
          customProperty {
            id
            name
          }
          productID
          value
        }
      }
      company {
        id
        companyName
        annualIncome
        numberEmployees
        businessType
        superAdminID
        superAdmin {
          id
          name
          familyName
          email
          phoneNumber
          role
          status
          color
          isConnected
          companyID
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      variants {
        items {
          id
          name
          img
          barcode
          defaultPrice
          defaultCost
          sku
          companyID
          productID
          rawMaterials {
            items {
              id
              companyID
              variantID
              rawMaterialID
              rawMaterialQuantity
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      attributes {
        items {
          id
          name
          options
          remember
          companyID
          productID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

export const customersByCompanyIDAndEmail = /* GraphQL */ `
  query CustomersByCompanyIDAndEmail(
    $companyID: ID!
    $email: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customersByCompanyIDAndEmail(
      companyID: $companyID
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        name
        email
        phoneNumber
        governmentID
        orders {
          nextToken
        }
        campaigns {
          nextToken
        }
        campaignsSMS {
          nextToken
        }
        countryID
        invoicing
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const customersByCompanyIDAndPhoneNumber = /* GraphQL */ `
  query CustomersByCompanyIDAndPhoneNumber(
    $companyID: ID!
    $phoneNumber: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customersByCompanyIDAndPhoneNumber(
      companyID: $companyID
      phoneNumber: $phoneNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        name
        email
        phoneNumber
        governmentID
        orders {
          nextToken
        }
        campaigns {
          nextToken
        }
        campaignsSMS {
          nextToken
        }
        countryID
        invoicing
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const customersByCompanyIDAndGovernmentID = /* GraphQL */ `
  query CustomersByCompanyIDAndGovernmentID(
    $companyID: ID!
    $governmentID: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customersByCompanyIDAndGovernmentID(
      companyID: $companyID
      governmentID: $governmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        name
        email
        phoneNumber
        governmentID
        orders {
          nextToken
        }
        campaigns {
          nextToken
        }
        campaignsSMS {
          nextToken
        }
        countryID
        invoicing
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listVariants = /* GraphQL */ `
  query ListVariants(
    $filter: ModelVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVariants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        productName
        img
        barcode
        sku
        defaultPrice
        type
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        productID
        product {
          id
          type
          name
          categoryID
          img
          units
          description
          companyID
          createdAt
          updatedAt
        }
        inventory {
          items {
            id
            price
            stockLevel
            stockAlert
            variantID
            locationID
            location {
              id
              name
            }
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const inventoriesByLocationIDAndVariantID = /* GraphQL */ `
  query InventoriesByLocationIDAndVariantID(
    $locationID: ID!
    $variantID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoriesByLocationIDAndVariantID(
      locationID: $locationID
      variantID: $variantID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        price
        currency
        stockLevel
        stockAlert
        companyID
        variantID
        variant {
          id
          name
          productName
          img
          barcode
          sku
          defaultPrice
          type
          companyID
          productID
          countryID
          createdAt
          updatedAt
        }
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getVariant = /* GraphQL */ `
  query GetVariant($id: ID!) {
    getVariant(id: $id) {
      id
      name
      productName
      img
      barcode
      sku
      defaultPrice
      type
      companyID
      rawMaterials {
        items {
          id
          companyID
          variantID
          rawMaterialID
          rawMaterial {
            id
            name
            barcode
            sku
            searchHelper
            isPerishable
            description
            units
            companyID
            countryID
            rawMaterialInventory {
              items {
                id
                stockLevel
                stockAlert
                companyID
                rawMaterialID
                locationID
                location {
                  id
                  name
                }
                countryID
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          rawMaterialQuantity
          createdAt
          updatedAt
        }
        nextToken
      }
      productID
      product {
        id
        type
        name
        categoryID
        category {
          name
        }
        img
        units
        description
        companyID
        isPerishable
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      inventory {
        items {
          id
          price
          currency
          stockLevel
          companyID
          variantID
          locationID
          createdAt
          updatedAt
        }
        nextToken
      }
      users {
        items {
          id
          companyID
          variantID
          userID
          countryID
          createdAt
          updatedAt
        }
        nextToken
      }
      taxes {
        items {
          tax {
            id
            name
            percentage
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const listPaymentMethods = /* GraphQL */ `
  query ListPaymentMethods(
    $filter: ModelPaymentMethodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentMethods(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        active
        countryID
        country {
          id
          name
          language
          currency
          phonePrefix
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getInventory = /* GraphQL */ `
  query GetInventory($id: ID!) {
    getInventory(id: $id) {
      id
      cost
      price
      currency
      stockLevel
      companyID
      variantID
      variant {
        id
        name
        productName
        img
        barcode
        sku
        defaultPrice
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        productID
        product {
          id
          type
          name
          categoryID
          img
          units
          description
          companyID
          createdAt
          updatedAt
        }
        inventory {
          nextToken
        }
        orders {
          nextToken
        }
        createdAt
        updatedAt
      }
      locationID
      location {
        id
        name
        locationType
        country
        cityID
        city {
          id
          timeZone
        }
        address
        postalCode
        lon
        lat
        active
        inStore
        pickCollect
        deliveries
        img
        companyID
        cashiers {
          items {
            id
            name
          }
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const listOrders = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        totalPrice
        totalTax
        totalDiscount
        currency
        locationID
        location {
          id
          name
          locationType
          country
          city
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          createdAt
          updatedAt
        }
        locationJSON
        companyID
        userID
        user {
          id
          name
          familyName
          email
          phoneNumber
          role
          status
          color
          isConnected
          companyID
          createdAt
          updatedAt
        }
        userJSON
        saleChannel
        paymentMethodID
        paymentMethod {
          id
          name
          description
          active
          countryID
          createdAt
          updatedAt
        }
        paymentConfirm
        deliveryConfirm
        customerID
        variants {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listCategories = /* GraphQL */ `
  query ListCategories(
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        type
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const inventoriesByVariantIDAndLocationID = /* GraphQL */ `
  query InventoriesByVariantIDAndLocationID(
    $variantID: ID!
    $locationID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoriesByVariantIDAndLocationID(
      variantID: $variantID
      locationID: $locationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        price
        currency
        stockLevel
        stockAlert
        companyID
        variantID
        locationID
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listFavorites = /* GraphQL */ `
  query ListFavorites(
    $filter: ModelFavoritesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFavorites(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productID
        locationID
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const favoritesByLocationID = /* GraphQL */ `
  query FavoritesByLocationID(
    $locationID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelFavoritesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    favoritesByLocationID(
      locationID: $locationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productID
        locationID
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const variantsByBarcode = /* GraphQL */ `
  query VariantsByBarcode(
    $barcode: String!
    $sortDirection: ModelSortDirection
    $filter: ModelVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    variantsByBarcode(
      barcode: $barcode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        productName
        img
        barcode
        sku
        defaultPrice
        type
        companyID
        rawMaterials {
          items {
            rawMaterialID
            rawMaterialQuantity
            rawMaterial {
              id
              name
              barcode
              sku
              searchHelper
              isPerishable
              description
              units
              companyID
              countryID
              rawMaterialInventory {
                items {
                  id
                  stockLevel
                  stockAlert
                  companyID
                  rawMaterialID
                  locationID
                  countryID
                }
              }
              createdAt
              updatedAt
            }
          }
        }
        productID
        product {
          id
          type
          name
          realName
          categoryID
          img
          color
          units
          description
          isPerishable
          companyID
          createdAt
          updatedAt
        }
        inventory {
          items {
            id
            price
            stockLevel
            stockAlert
            variantID
            locationID
            location {
              id
              name
            }
          }
        }
        taxes {
          items {
            tax {
              id
              name
              percentage
            }
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const variantsBySku = /* GraphQL */ `
  query VariantsBySku(
    $sku: String!
    $sortDirection: ModelSortDirection
    $filter: ModelVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    variantsBySku(
      sku: $sku
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        productName
        img
        barcode
        sku
        defaultPrice
        type
        searchHelper
        companyID
        productID
        productID
        product {
          id
          type
          name
          realName
          categoryID
          img
          color
          units
          description
          isPerishable
          companyID
          createdAt
          updatedAt
        }
        countryID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getTax = /* GraphQL */ `
  query GetTax($id: ID!) {
    getTax(id: $id) {
      id
      name
      description
      percentage
      byLocation
      byProduct
      companyID
      locations {
        items {
          id
          companyID
          taxID
          locationID
          createdAt
          updatedAt
        }
        nextToken
      }
      variants {
        items {
          id
          companyID
          taxID
          variantID
          productID
          createdAt
          updatedAt
        }
        nextToken
      }
      countryID
      createdAt
      updatedAt
    }
  }
`;

export const listTaxes = /* GraphQL */ `
  query ListTaxes(
    $filter: ModelTaxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaxes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        percentage
        byLocation
        byProduct
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          createdAt
          updatedAt
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const taxLocationsByTaxIDAndCompanyID = /* GraphQL */ `
  query TaxLocationsByTaxIDAndCompanyID(
    $taxID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTaxLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taxLocationsByTaxIDAndCompanyID(
      taxID: $taxID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        taxID
        tax {
          id
          name
          description
          percentage
          byLocation
          byProduct
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const taxLocationsByLocationIDAndCompanyID = /* GraphQL */ `
  query TaxLocationsByLocationIDAndCompanyID(
    $locationID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTaxLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taxLocationsByLocationIDAndCompanyID(
      locationID: $locationID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        taxID
        tax {
          id
          name
          description
          percentage
          byLocation
          byProduct
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const taxVariantsByTaxIDAndCompanyID = /* GraphQL */ `
  query TaxVariantsByTaxIDAndCompanyID(
    $taxID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTaxVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taxVariantsByTaxIDAndCompanyID(
      taxID: $taxID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        taxID
        tax {
          id
          name
          description
          percentage
          byLocation
          byProduct
          companyID
          countryID
          createdAt
          updatedAt
        }
        variantID
        variant {
          id
          name
          productName
          img
          barcode
          sku
          defaultPrice
          type
          companyID
          productID
          countryID
          createdAt
          updatedAt
        }
        productID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const taxVariantsByVariantIDAndCompanyID = /* GraphQL */ `
  query TaxVariantsByVariantIDAndCompanyID(
    $variantID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTaxVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taxVariantsByVariantIDAndCompanyID(
      variantID: $variantID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        taxID
        variantID
        productID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const categoriesByCompanyIDAndType = /* GraphQL */ `
  query CategoriesByCompanyIDAndType(
    $companyID: ID!
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    categoriesByCompanyIDAndType(
      companyID: $companyID
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        type
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          createdAt
          updatedAt
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const productsByCompanyIDAndType = /* GraphQL */ `
  query ProductsByCompanyIDAndType(
    $companyID: ID!
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByCompanyIDAndType(
      companyID: $companyID
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        name
        realName
        categoryID
        actionStatus
        category {
          id
          name
        }
        img
        color
        units
        description
        companyID
        isPerishable
        actionStatus
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          createdAt
          updatedAt
        }
        variants(limit: 40) {
          items {
            id
            name
            productName
            img
            sku
            defaultPrice
            barcode
            promotion {
              items {
                promotionID
                promotion {
                  id
                  type
                  dateInit
                  dateEnd
                  fixedAmount
                  percentageAmount
                  amountMinPurchase
                  applyListProduct
                  applyAmountMinAllPurchase
                  applyAmountMinProducts
                  applySpecificProducts
                  applyamountMin
                  applyLimit
                  applySpecificLocation
                  applySpecificDaysTimes
                  applycumulative
                  applyListCustomer
                  applyAnonymousSales
                  finishAccordingBudget
                  finishAccordingBudgetValue
                  applyMaxAmountForSale
                  applyMaxAmountForSaleValue
                  applyMaxAmountForCustomer
                  applyMaxAmountForCustomerValue
                  applyTransactionsMaxForCustomer
                  applyTransactionsMaxForCustomerValue
                }
              }
            }
            rawMaterials {
              items {
                rawMaterialID
                rawMaterialQuantity
                rawMaterial {
                  id
                  name
                  barcode
                  sku
                  searchHelper
                  isPerishable
                  description
                  units
                  companyID
                  countryID
                  rawMaterialInventory {
                    items {
                      id
                      stockLevel
                      stockAlert
                      companyID
                      rawMaterialID
                      locationID
                      countryID
                    }
                  }
                  createdAt
                  updatedAt
                }
              }
            }
            type
            taxes {
              items {
                tax {
                  id
                  name
                  percentage
                }
              }
            }
            users {
              items {
                id
                commission
                commissionType
                enabled
                userID
                variantID
                user {
                  id
                  name
                  familyName
                  locations {
                    items {
                      id
                      companyID
                      locationID
                      userID
                    }
                  }
                }
              }
            }
          }
          nextToken
        }
        attributes {
          items {
            id
            name
            options
            order
          }
        }
        vendorProducts {
          items {
            vendorID
          }
        }

        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const prodyctsByCompanyIDAndTypeOffline = /* GraphQL */ `
  query ProductsByCompanyIDAndType(
    $companyID: ID!
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByCompanyIDAndType(
      companyID: $companyID
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        name
        realName
        categoryID
        category {
          id
          name
        }
        img
        color
        units
        description
        companyID
        isPerishable
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          createdAt
          updatedAt
        }
        variants {
          items {
            id
            name
            productName
            img
            sku
            defaultPrice
            barcode

            inventory {
              items {
                id
                price
                stockLevel
                stockAlert
                variantID
                locationID
                location {
                  id
                  name
                }
              }
            }

            promotion {
              items {
                promotionID
                promotion {
                  id
                  type
                  dateInit
                  dateEnd
                  fixedAmount
                  percentageAmount
                  amountMinPurchase
                  applyListProduct
                  applyAmountMinAllPurchase
                  applyAmountMinProducts
                  applySpecificProducts
                  applyamountMin
                  applyLimit
                  applySpecificLocation
                  applySpecificDaysTimes
                  applycumulative
                  applyListCustomer
                  applyAnonymousSales
                  finishAccordingBudget
                  finishAccordingBudgetValue
                  applyMaxAmountForSale
                  applyMaxAmountForSaleValue
                  applyMaxAmountForCustomer
                  applyMaxAmountForCustomerValue
                  applyTransactionsMaxForCustomer
                  applyTransactionsMaxForCustomerValue
                }
              }
            }
            rawMaterials {
              items {
                rawMaterialID
                rawMaterialQuantity
                rawMaterial {
                  id
                  name
                  barcode
                  sku
                  searchHelper
                  isPerishable
                  description
                  units
                  companyID
                  countryID
                  rawMaterialInventory {
                    items {
                      id
                      stockLevel
                      stockAlert
                      companyID
                      rawMaterialID
                      locationID
                      countryID
                    }
                  }
                  createdAt
                  updatedAt
                }
              }
            }
            type
            taxes {
              items {
                tax {
                  id
                  name
                  percentage
                }
              }
            }
            users {
              items {
                id
                commission
                commissionType
                enabled
                variantID
                user {
                  id
                  name
                  familyName
                  locations {
                    items {
                      id
                      companyID
                      locationID
                      userID
                    }
                  }
                }
              }
            }
          }
        }
        attributes {
          items {
            id
            name
            options
            order
          }
        }
        vendorProducts {
          items {
            vendorID
          }
        }

        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const productsByCategoryIDAndType = /* GraphQL */ `
  query ProductsByCategoryIDAndType(
    $categoryID: ID!
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByCategoryIDAndType(
      categoryID: $categoryID
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        name
        categoryID
        category {
          id
          name
        }
        img
        color
        units
        description
        companyID
        isPerishable
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          createdAt
          updatedAt
        }
        variants {
          items {
            id
            name
            productName
            img
            sku
            defaultPrice
            barcode
            promotion {
              items {
                promotionID
                promotion {
                  id
                  type
                  dateInit
                  dateEnd
                  fixedAmount
                  percentageAmount
                  amountMinPurchase
                  applyListProduct
                  applyAmountMinAllPurchase
                  applyAmountMinProducts
                  applySpecificProducts
                  applyamountMin
                  applyLimit
                  applySpecificLocation
                  applySpecificDaysTimes
                  applycumulative
                  applyListCustomer
                  applyAnonymousSales
                  finishAccordingBudget
                  finishAccordingBudgetValue
                  applyMaxAmountForSale
                  applyMaxAmountForSaleValue
                  applyMaxAmountForCustomer
                  applyMaxAmountForCustomerValue
                  applyTransactionsMaxForCustomer
                  applyTransactionsMaxForCustomerValue
                }
              }
            }
            rawMaterials {
              items {
                rawMaterialID
                rawMaterialQuantity
                rawMaterial {
                  id
                  name
                  barcode
                  sku
                  searchHelper
                  isPerishable
                  description
                  units
                  companyID
                  countryID
                  rawMaterialInventory {
                    items {
                      id
                      stockLevel
                      stockAlert
                      companyID
                      rawMaterialID
                      locationID
                      countryID
                    }
                  }
                  createdAt
                  updatedAt
                }
              }
            }
            type
            taxes {
              items {
                tax {
                  id
                  name
                  percentage
                }
              }
            }
            users {
              items {
                id
                commission
                commissionType
                enabled
                variantID
                user {
                  id
                  name
                  familyName
                  locations {
                    items {
                      id
                      companyID
                      locationID
                      userID
                    }
                  }
                }
              }
            }
          }
        }
        attributes {
          items {
            id
            name
            options
            order
          }
        }
        vendorProducts {
          items {
            vendorID
          }
        }

        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const recommendationsByCompanyID = /* GraphQL */ `
  query RecommendationsByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRecommendationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    recommendationsByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productID
        product {
          id
          type
          name
          categoryID
          img
          color
          units
          minDuration
          description
          isPerishable
          companyID
          countryID
          variants {
            items {
              id
              name
              barcode
              sku
            }
          }
          createdAt
          updatedAt
        }
        locations {
          items {
            locationID
          }
        }
        companyID
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const productsByCompanyIDAndName = /* GraphQL */ `
  query ProductsByCompanyIDAndName(
    $companyID: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByCompanyIDAndName(
      companyID: $companyID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        name
        categoryID
        category {
          id
          name
        }
        img
        color
        description
        isPerishable
        companyID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const variantsByCompanyIDAndType = /* GraphQL */ `
  query VariantsByCompanyIDAndType(
    $companyID: ID!
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    variantsByCompanyIDAndType(
      companyID: $companyID
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        productName
        img
        barcode
        sku
        defaultPrice
        searchHelper
        type
        rawMaterials {
          items {
            id
          }
        }
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        productID
        product {
          id
          type
          name
          realName
          categoryID
          category {
            name
          }
          img
          color
          units
          description
          isPerishable
          vendorProducts {
            items {
              id
              vendorID
              vendor {
                name
              }
            }
          }
          attributes {
            items {
              id
              name
            }
          }
          companyID
          createdAt
          updatedAt
        }
        inventory {
          items {
            id
            price
            reSellerFinalPrice
            cost
            stockLevel
            stockAlert
            variantID
            locationID
            location {
              id
              name
            }
          }
        }
        users {
          items {
            id
            commission
            commissionType
            enabled
            variantID
            userID
            user {
              id
              name
              familyName
            }
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const productCustomPropertiesByProductIDAndCompanyID = /* GraphQL */ `
  query ProductCustomPropertiesByProductIDAndCompanyID(
    $productID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductCustomPropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productCustomPropertiesByProductIDAndCompanyID(
      productID: $productID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productID
        product {
          id
          type
          name
          categoryID
          img
          color
          units
          minDuration
          customOneName
          customOneValue
          customTwoName
          customTwoValue
          customThreeName
          customThreeValue
          description
          isPerishable
          companyID
          countryID
          createdAt
          updatedAt
        }
        customPropertyID
        customProperty {
          id
          name
          options
          companyID
          countryID
          createdAt
          updatedAt
        }
        value
        companyID
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const productCustomPropertiesByCustomPropertyIDAndValue = /* GraphQL */ `
  query ProductCustomPropertiesByCustomPropertyIDAndValue(
    $customPropertyID: ID!
    $value: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductCustomPropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productCustomPropertiesByCustomPropertyIDAndValue(
      customPropertyID: $customPropertyID
      value: $value
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productID
        product {
          id
          type
          name
          realName
          categoryID
          category {
            id
            name
          }
          img
          color
          units
          description
          companyID
          isPerishable
          company {
            id
            companyName
            annualIncome
            numberEmployees
            businessType
            companyLogo
            companyWebpage
            superAdminID
            createdAt
            updatedAt
          }
          variants {
            items {
              id
              name
              productName
              img
              sku
              defaultPrice
              barcode
              promotion {
                items {
                  promotionID
                  promotion {
                    id
                    type
                    dateInit
                    dateEnd
                    fixedAmount
                    percentageAmount
                    amountMinPurchase
                    applyListProduct
                    applyAmountMinAllPurchase
                    applyAmountMinProducts
                    applySpecificProducts
                    applyamountMin
                    applyLimit
                    applySpecificLocation
                    applySpecificDaysTimes
                    applycumulative
                    applyListCustomer
                    applyAnonymousSales
                    finishAccordingBudget
                    finishAccordingBudgetValue
                    applyMaxAmountForSale
                    applyMaxAmountForSaleValue
                    applyMaxAmountForCustomer
                    applyMaxAmountForCustomerValue
                    applyTransactionsMaxForCustomer
                    applyTransactionsMaxForCustomerValue
                  }
                }
              }
              rawMaterials {
                items {
                  rawMaterialID
                  rawMaterialQuantity
                  rawMaterial {
                    id
                    name
                    barcode
                    sku
                    searchHelper
                    isPerishable
                    description
                    units
                    companyID
                    countryID
                    rawMaterialInventory {
                      items {
                        id
                        stockLevel
                        stockAlert
                        companyID
                        rawMaterialID
                        locationID
                        countryID
                      }
                    }
                    createdAt
                    updatedAt
                  }
                }
              }
              type
              taxes {
                items {
                  tax {
                    id
                    name
                    percentage
                  }
                }
              }
              users {
                items {
                  id
                  commission
                  commissionType
                  enabled
                  variantID
                  user {
                    id
                    name
                    familyName
                    locations {
                      items {
                        id
                        companyID
                        locationID
                        userID
                      }
                    }
                  }
                }
              }
            }
          }
          attributes {
            items {
              id
              name
              options
              order
            }
          }
          vendorProducts {
            items {
              vendorID
            }
          }

          countryID
          createdAt
          updatedAt
        }
        customPropertyID
        customProperty {
          id
          name
          options
          companyID
          countryID
          createdAt
          updatedAt
        }
        value
        companyID
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const customPropertiesByCompanyIDAndName = /* GraphQL */ `
  query CustomPropertiesByCompanyIDAndName(
    $companyID: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomPropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customPropertiesByCompanyIDAndName(
      companyID: $companyID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        options
        companyID
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const variantsByCountryID = /* GraphQL */ `
  query VariantsByCountryID(
    $countryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    variantsByCountryID(
      countryID: $countryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        productName
        img
        barcode
        sku
        defaultPrice
        type
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          superAdminID
          createdAt
          updatedAt
        }
        productID
        product {
          id
          type
          name
          categoryID
          img
          units
          description
          isPerishable
          companyID
          createdAt
          updatedAt
        }
        inventory {
          items {
            id
            price
            stockLevel
            stockAlert
            variantID
            locationID
            location {
              id
              name
            }
          }
        }
        users {
          items {
            id
            commission
            commissionType
            enabled
            variantID
            userID
            user {
              id
              name
              familyName
            }
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const taxesByCompanyIDAndName = /* GraphQL */ `
  query TaxesByCompanyIDAndName(
    $companyID: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTaxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taxesByCompanyIDAndName(
      companyID: $companyID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        percentage
        byLocation
        byProduct
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          createdAt
          updatedAt
        }
        locations {
          items {
            id
            location {
              id
              name
            }
          }
        }
        variants {
          items {
            id
            variant {
              id
              name
            }
          }
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const taxesByCountryID = /* GraphQL */ `
  query TaxesByCountryID(
    $countryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTaxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taxesByCountryID(
      countryID: $countryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        percentage
        byLocation
        byProduct
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          createdAt
          updatedAt
        }
        locations {
          items {
            id
            location {
              id
              name
            }
          }
        }
        variants {
          items {
            id
            variant {
              id
              name
            }
          }
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const locationsByCountryID = /* GraphQL */ `
  query LocationsByCountryID(
    $countryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationsByCountryID(
      countryID: $countryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        locationType
        country
        cityID
        address
        postalCode
        lon
        lat
        active
        inStore
        pickCollect
        deliveries
        img
        city {
          name
          timeZone
        }
        cashiers {
          items {
            id
            name
          }
        }
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          createdAt
          updatedAt
        }
        users {
          items {
            user {
              id
              familyName
              name
              email
            }
          }
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const locationsByCompanyID = /* GraphQL */ `
  query LocationsByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationsByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        realName
        locationType
        country
        cityID
        address
        postalCode
        lon
        lat
        active
        inStore
        pickCollect
        deliveries
        automaticTreasuryAccountID
        img
        city {
          name
          timeZone
        }
        cashiers {
          items {
            id
            name
          }
        }
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          createdAt
          updatedAt
        }
        users {
          items {
            user {
              id
              familyName
              name
              email
            }
          }
        }
        countryID

        taxes {
          items {
            id
            taxID
            tax {
              id
              name
              percentage
            }
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const paymentMethodCompaniesByCompanyID = /* GraphQL */ `
  query PaymentMethodCompaniesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentMethodCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    paymentMethodCompaniesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        paymentMethodID
        paymentMethod {
          id
          name
          description
          active
          icon
          paymentDetails
          type
          countryID
          createdAt
          updatedAt
        }
        automaticTreasuryAccountID
      }
      nextToken
      __typename
    }
  }
`;

export const locationsByName = /* GraphQL */ `
  query LocationsByName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationsByName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        locationType
        country
        cityID
        address
        postalCode
        lon
        lat
        active
        inStore
        pickCollect
        deliveries
        img
        companyID
        countryID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const paymentMethodCompaniesByPaymentMethodID = /* GraphQL */ `
  query PaymentMethodCompaniesByPaymentMethodID(
    $paymentMethodID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentMethodCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    paymentMethodCompaniesByPaymentMethodID(
      paymentMethodID: $paymentMethodID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        paymentMethodID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const paymentMethodsByCountryIDAndName = /* GraphQL */ `
  query PaymentMethodsByCountryIDAndName(
    $countryID: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentMethodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    paymentMethodsByCountryIDAndName(
      countryID: $countryID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        active
        icon
        paymentDetails
        type
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const campaignsByCountryID = /* GraphQL */ `
  query CampaignsByCountryID(
    $countryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    campaignsByCountryID(
      countryID: $countryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        type
        name
        sender
        customers {
          items {
            id
          }
        }
        customersSMS {
          items {
            id
          }
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const customersByCompanyIDAndCountryID = /* GraphQL */ `
  query CustomersByCompanyIDAndCountryID(
    $companyID: ID!
    $countryID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customersByCompanyIDAndCountryID(
      companyID: $companyID
      countryID: $countryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        name
        email
        phoneNumber
        governmentID
        orders {
          items {
            id
            createdAtLocal
          }
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getFidelityProgram = /* GraphQL */ `
  query GetFidelityProgram($id: ID!) {
    getFidelityProgram(id: $id) {
      id
      programName
      monetaryValuePoints
      monetaryValueCurrency
      isExpirationEnabled
      expirationDays
      pointsLimitEnabled
      maxPoints
      minPoints
      activitiesChecked
      discountLevels
      pointsPerPurchase
      redeemablePoints
      statusProgram
      companyID
      products {
        items {
          id
          fidelityProgramID
          productID
          product {
            id
            type
            name
            realName
            categoryID
            img
            color
            units
            minDuration
            customOneName
            customOneValue
            customTwoName
            customTwoValue
            customThreeName
            customThreeValue
            description
            isPerishable
            companyID
            countryID
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      categories {
        items {
          id
          fidelityProgramID
          categoryID
          multiplier
          category {
            id
            name
            type
            companyID
            company {
              id
              companyName
              annualIncome
              numberEmployees
              businessType
              companyLogo
              companyWebpage
              phoneNumber
              mainEmail
              mainName
              superAdminID
              mainCountryID
              isNew
              saleObjective
              crmID
              ipAddress
              userAgent
              createdAt
              updatedAt
            }
          }
        }
        nextToken
      }
      fidelityLevels {
        items {
          id
          fidelityProgramID
          name
          minPoints
          maxPoints
          color
          benefitID
          benefit {
            discountToClients
            discountPercentage
            pointMultiplier
            multiplier
            freeShipping
            specialPromotions
            companyID
            id
            createdAt
            updatedAt
          }
          companyID
          createdAt
          updatedAt
        }
        nextToken
      }
      redemptionOptions
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const customersByEmail = /* GraphQL */ `
  query CustomersByEmail(
    $email: AWSEmail!
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customersByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        companyID
        name
        email
        phoneNumber
        governmentID
        fidelityProgramCustomer {
          items {
            id
            programID
            program {
              id
              programName
              monetaryValuePoints
              monetaryValueCurrency
              isExpirationEnabled
              expirationDays
              pointsLimitEnabled
              maxPoints
              minPoints
              activitiesChecked
              discountLevels
              pointsPerPurchase
              redeemablePoints
              statusProgram
              companyID
              products {
                items {
                  id
                  fidelityProgramID
                  productID
                  companyID
                  multiplier
                  createdAt
                  updatedAt
                }
                nextToken
              }
              categories {
                items {
                  id
                  fidelityProgramID
                  categoryID
                  companyID
                  multiplier
                  createdAt
                  updatedAt
                }
                nextToken
              }
              fidelityLevels {
                items {
                  id
                  fidelityProgramID
                  name
                  minPoints
                  maxPoints
                  color
                  benefitID
                  benefit {
                    discountToClients
                    discountPercentage
                    pointMultiplier
                    multiplier
                    freeShipping
                    specialPromotions
                    companyID
                    id
                    createdAt
                    updatedAt
                  }
                  companyID
                  createdAt
                  updatedAt
                }
                nextToken
              }
              redemptionOptions
              createdAt
              updatedAt
            }

            fidelityProgramHistory {
              items {
                id
                points
                totalPoints
                pointsType
                createdAt
                updatedAt
              }
              nextToken
            }
          }
        }
        orders {
          items {
            id
            createdAtLocal
            variants {
              items {
                id
                variant {
                  id
                  name
                  productName
                  product {
                    id
                    type
                    name
                    categoryID
                    category {
                      id
                      name
                    }
                    img
                    color
                    units
                    description
                    companyID
                    isPerishable
                    company {
                      id
                      companyName
                      annualIncome
                      numberEmployees
                      businessType
                      companyLogo
                      companyWebpage
                      superAdminID
                      createdAt
                      updatedAt
                    }
                    variants {
                      items {
                        id
                        name
                        productName
                        img
                        sku
                        barcode
                        rawMaterials {
                          items {
                            rawMaterialID
                            rawMaterialQuantity
                          }
                        }
                        type
                        taxes {
                          items {
                            tax {
                              id
                              name
                              percentage
                            }
                          }
                        }
                        users {
                          items {
                            id
                            commission
                            commissionType
                            enabled
                            variantID
                            user {
                              id
                              name
                              familyName
                              locations {
                                items {
                                  id
                                  companyID
                                  locationID
                                  userID
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    attributes {
                      items {
                        id
                        name
                        options
                        order
                      }
                    }
                    vendorProducts {
                      items {
                        vendorID
                      }
                    }

                    countryID
                  }
                }
              }
            }
          }
          nextToken
        }
        invoicing
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const customersByPhoneNumber = /* GraphQL */ `
  query CustomersByPhoneNumber(
    $phoneNumber: Float!
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customersByPhoneNumber(
      phoneNumber: $phoneNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        name
        email
        phoneNumber
        governmentID
        fidelityProgramCustomer {
          items {
            id
            programID
            program {
              id
              programName
              monetaryValuePoints
              monetaryValueCurrency
              isExpirationEnabled
              expirationDays
              pointsLimitEnabled
              maxPoints
              minPoints
              activitiesChecked
              discountLevels
              pointsPerPurchase
              redeemablePoints
              statusProgram
              companyID
              products {
                items {
                  id
                  fidelityProgramID
                  productID
                  product {
                    id
                    type
                    name
                    realName
                    variants {
                      nextToken
                    }
                    customProperty {
                      nextToken
                    }
                    fidelityProgram {
                      nextToken
                    }
                    attributes {
                      nextToken
                    }
                    countryID
                    vendorProducts {
                      nextToken
                    }
                    purchaseOrderProducts {
                      nextToken
                    }
                    createdAt
                    updatedAt
                  }
                  companyID
                  multiplier
                }
                nextToken
              }

              categories {
                items {
                  id
                  fidelityProgramID
                  categoryID
                  companyID
                  multiplier
                }
                nextToken
              }

              fidelityLevels {
                items {
                  id
                  fidelityProgramID
                  name
                  minPoints
                  maxPoints
                  color
                  benefitID
                  benefit {
                    discountToClients
                    discountPercentage
                    pointMultiplier
                    multiplier
                    freeShipping
                    specialPromotions
                    companyID
                  }
                  companyID
                  createdAt
                  updatedAt
                }
                nextToken
              }
              redemptionOptions
              createdAt
              updatedAt
            }

            fidelityProgramHistory {
              items {
                id
                points
                totalPoints
                pointsType
                createdAt
                updatedAt
              }
              nextToken
            }
          }
        }
        orders {
          items {
            id
            createdAtLocal
            variants {
              items {
                id
                variant {
                  id
                  name
                  productName
                  product {
                    id
                    type
                    name
                    categoryID
                    category {
                      id
                      name
                    }
                    img
                    color
                    units
                    description
                    companyID
                    isPerishable
                    company {
                      id
                      companyName
                      annualIncome
                      numberEmployees
                      businessType
                      companyLogo
                      companyWebpage
                      superAdminID
                      createdAt
                      updatedAt
                    }
                    variants {
                      items {
                        id
                        name
                        productName
                        img
                        sku
                        barcode
                        rawMaterials {
                          items {
                            rawMaterialID
                            rawMaterialQuantity
                          }
                        }
                        type
                        taxes {
                          items {
                            tax {
                              id
                              name
                              percentage
                            }
                          }
                        }
                        users {
                          items {
                            id
                            commission
                            commissionType
                            enabled
                            variantID
                            user {
                              id
                              name
                              familyName
                              locations {
                                items {
                                  id
                                  companyID
                                  locationID
                                  userID
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    attributes {
                      items {
                        id
                        name
                        options
                        order
                      }
                    }
                    vendorProducts {
                      items {
                        vendorID
                      }
                    }

                    countryID
                  }
                }
              }
            }
          }
          nextToken
        }
        countryID
        invoicing
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const customersByGovernmentID = /* GraphQL */ `
  query CustomersByGovernmentID(
    $governmentID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customersByGovernmentID(
      governmentID: $governmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        name
        email
        phoneNumber
        governmentID
        fidelityProgramCustomer {
          items {
            id
            programID
            program {
              id
              programName
              monetaryValuePoints
              monetaryValueCurrency
              isExpirationEnabled
              expirationDays
              pointsLimitEnabled
              maxPoints
              minPoints
              activitiesChecked
              discountLevels
              pointsPerPurchase
              redeemablePoints
              statusProgram
              companyID
              products {
                items {
                  id
                  fidelityProgramID
                  productID
                  product {
                    id
                    type
                    name
                    realName
                    variants {
                      nextToken
                    }
                    customProperty {
                      nextToken
                    }
                    fidelityProgram {
                      nextToken
                    }
                    attributes {
                      nextToken
                    }
                    countryID
                    vendorProducts {
                      nextToken
                    }
                    purchaseOrderProducts {
                      nextToken
                    }
                    createdAt
                    updatedAt
                  }
                  companyID
                  multiplier
                }
                nextToken
              }
              categories {
                items {
                  id
                  fidelityProgramID
                  categoryID
                  companyID
                  multiplier
                }
                nextToken
              }
              fidelityLevels {
                items {
                  id
                  fidelityProgramID
                  name
                  minPoints
                  maxPoints
                  color
                  benefitID
                  benefit {
                    discountToClients
                    discountPercentage
                    pointMultiplier
                    multiplier
                    freeShipping
                    specialPromotions
                    companyID
                  }
                  companyID
                  createdAt
                  updatedAt
                }
                nextToken
              }
              redemptionOptions
              createdAt
              updatedAt
            }
            fidelityProgramHistory {
              items {
                id
                points
                totalPoints
                pointsType
                createdAt
                updatedAt
              }
              nextToken
            }
          }
        }
        orders {
          items {
            id
            createdAtLocal
            variants {
              items {
                id
                variant {
                  id
                  name
                  productName
                  product {
                    id
                    type
                    name
                    categoryID
                    category {
                      id
                      name
                    }
                    img
                    color
                    units
                    description
                    companyID
                    isPerishable
                    company {
                      id
                      companyName
                      annualIncome
                      numberEmployees
                      businessType
                      companyLogo
                      companyWebpage
                      superAdminID
                      createdAt
                      updatedAt
                    }
                    variants {
                      items {
                        id
                        name
                        productName
                        img
                        sku
                        barcode
                        rawMaterials {
                          items {
                            rawMaterialID
                            rawMaterialQuantity
                          }
                        }
                        type
                        taxes {
                          items {
                            tax {
                              id
                              name
                              percentage
                            }
                          }
                        }
                        users {
                          items {
                            id
                            commission
                            commissionType
                            enabled
                            variantID
                            user {
                              id
                              name
                              familyName
                              locations {
                                items {
                                  id
                                  companyID
                                  locationID
                                  userID
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    attributes {
                      items {
                        id
                        name
                        options
                        order
                      }
                    }
                    vendorProducts {
                      items {
                        vendorID
                      }
                    }

                    countryID
                  }
                }
              }
            }
          }
          nextToken
        }
        countryID
        invoicing
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const ordersByLocationIDAndCreatedAtLocal = /* GraphQL */ `
  query OrdersByLocationIDAndCreatedAtLocal(
    $locationID: ID!
    $createdAtLocal: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByLocationIDAndCreatedAtLocal(
      locationID: $locationID
      createdAtLocal: $createdAtLocal
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subTotalOne
        totalDiscount
        subTotalTwo
        totalTax
        totalPrice
        paidPrice
        currency
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationJSON
        companyID
        userID
        user {
          name
          familyName
        }
        userJSON
        saleChannel
        paymentMethod {
          items {
            paymentMethod {
              id
              name
            }
          }
        }
        paymentConfirm
        deliveryConfirm
        customerID
        customer {
          id
          companyID
          name
          email
          phoneNumber
          governmentID
          countryID
          createdAt
          updatedAt
        }
        variants {
          items {
            variant {
              id
              productName
              name
              sku
            }
          }
        }
        canceled
        createdAtLocal
        createdAt
        updatedAt
        countryID
      }
      nextToken
    }
  }
`;

export const ordersByCompanyIDAndCreatedAtLocal = /* GraphQL */ `
  query OrdersByCompanyIDAndCreatedAtLocal(
    $companyID: ID!
    $createdAtLocal: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByCompanyIDAndCreatedAtLocal(
      companyID: $companyID
      createdAtLocal: $createdAtLocal
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        receiptNumber
        subTotalOne
        totalDiscount
        subTotalTwo
        totalTax
        taxType
        status
        tip
        totalPrice
        paidPrice
        currency
        invoicingElectronic
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationJSON
        companyID
        userID
        user {
          name
          familyName
        }
        userJSON
        cashierID
        cashier {
          id
          name
          locationID
          companyID
          countryID
          mainPrint
          secondaryPrint
          createdAt
          updatedAt
        }
        cashierJSON
        saleChannel
        paymentMethod {
          items {
            value
            isReturn
            paymentMethod {
              id
              name
            }
          }
        }
        paymentConfirm
        deliveryConfirm
        customerID
        customer {
          id
          companyID
          name
          email
          phoneNumber
          governmentID
          countryID
          createdAt
          updatedAt
        }
        variants {
          items {
            id
            companyID
            orderID
            variantID
            quantityCombo
            variant {
              id
              productName
              name
              barcode
              sku
              productID
              product {
                id
                name
                units
                categoryID
                category {
                  name
                }
              }
              img
              inventory {
                items {
                  id
                  price
                  currency
                  stockLevel
                  companyID
                  variantID
                  locationID
                  createdAt
                  updatedAt
                }
                nextToken
              }
              rawMaterials {
                items {
                  rawMaterialID
                  rawMaterialQuantity
                  rawMaterial {
                    id
                    name
                    barcode
                    sku
                    searchHelper
                    isPerishable
                    description
                    units
                    companyID
                    countryID
                    rawMaterialInventory {
                      items {
                        id
                        stockLevel
                        stockAlert
                        companyID
                        rawMaterialID
                        locationID
                        countryID
                      }
                    }
                    createdAt
                    updatedAt
                  }
                }
              }
              taxes {
                items {
                  tax {
                    id
                    name
                    percentage
                  }
                }
              }
            }
            finalPrice
            return
            userJSON
            variantJSON
            variantID
            salePrice
            discount
            finalPrice
            taxValue
            userJSON
            batchExpirationDate
            vendorCost
            purchaseOrderProductsID
            quantity
            returnQuantity
            returnQuantityCombo
            taxes
            return
            isFast
            variantJSON
            isCombo
            comboID
            promotion {
              id
              companyID
              countryID
              type
              name
              dateInit
              dateEnd
              fixedAmount
              priceCombo
              __typename
            }
            variant {
              id
              productName
              name
              sku
              type
            }
          }
        }
        canceled
        createdAtLocal
        createdAt
        updatedAt
        countryID
      }
      nextToken
    }
  }
`;

export const ordersByCountryIDAndCreatedAtLocal = /* GraphQL */ `
  query OrdersByCountryIDAndCreatedAtLocal(
    $countryID: ID!
    $createdAtLocal: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByCountryIDAndCreatedAtLocal(
      countryID: $countryID
      createdAtLocal: $createdAtLocal
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        receiptNumber
        subTotalOne
        totalDiscount
        subTotalTwo
        totalTax
        totalPrice
        paidPrice
        currency
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationJSON
        companyID
        userID
        user {
          name
          familyName
        }
        userJSON
        saleChannel
        paymentMethod {
          items {
            value
            paymentMethod {
              id
              name
            }
          }
        }
        paymentConfirm
        deliveryConfirm
        customerID
        customer {
          id
          companyID
          name
          email
          phoneNumber
          governmentID
          countryID
          createdAt
          updatedAt
        }
        variants {
          items {
            finalPrice
            return
            userJSON
            variantJSON
            variantID
            variant {
              id
              productName
              name
              sku
              type
            }
          }
        }
        canceled
        createdAtLocal
        createdAt
        updatedAt
        countryID
      }
      nextToken
    }
  }
`;

export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      subTotalOne
      deliveryBeforePayment
      totalDiscount
      subTotalTwo
      totalTax
      totalPrice
      totalWithholding
      paidPrice
      tip
      currency
      cashierID
      cashier {
        id
      }
      cashierJSON
      locationID
      taxType
      location {
        id
        name
        locationType
        country
        cityID
        city {
          id
          countryID
          name
          timeZone
          state
          createdAt
          updatedAt
        }
        address
        postalCode
        lon
        lat
        active
        inStore
        pickCollect
        deliveries
        taxes {
          items {
            taxID
            locationID
            companyID
            createdAt
          }
        }
        img
        companyID
        countryID
        createdAt
        updatedAt
      }
      locationJSON
      companyID
      userID
      user {
        name
        familyName
      }
      userJSON
      saleChannel
      paymentMethod {
        items {
          value
          isReturn
          paymentMethod {
            id
            name
          }
        }
      }
      paymentConfirm
      deliveryConfirm
      customerID
      customer {
        id
        companyID
        name
        email
        phoneNumber
        governmentID
        countryID
        invoicing
        createdAt
        updatedAt
      }
      variants(limit: 3500) {
        items {
          id
          companyID
          orderID
          variantID
          quantityCombo
          quantityDelivered
          inventoryBatches {
            items {
              id
              inventoryBatchesID
              inventoryBatches {
                id
                costUnit
              }
              usedQuantity
              vendorID
            }
          }
          variant {
            id
            productName
            name
            sku
            productID
            product {
              id
              name
              units
              categoryID
              category {
                name
              }
            }
            img
            inventory {
              items {
                id
                price
                currency
                stockLevel
                companyID
                variantID
                locationID
                createdAt
                updatedAt
              }
              nextToken
            }
            rawMaterials {
              items {
                rawMaterialID
                rawMaterialQuantity
                rawMaterial {
                  id
                  name
                  barcode
                  sku
                  searchHelper
                  isPerishable
                  description
                  units
                  companyID
                  countryID
                  rawMaterialInventory {
                    items {
                      id
                      stockLevel
                      stockAlert
                      companyID
                      rawMaterialID
                      locationID
                      countryID
                    }
                  }
                  createdAt
                  updatedAt
                }
              }
            }
            taxes {
              items {
                tax {
                  id
                  name
                  percentage
                }
              }
            }
          }
          salePrice
          discount
          finalPrice
          taxValue
          userJSON
          batchExpirationDate
          vendorCost
          purchaseOrderProductsID
          quantity
          returnQuantity
          returnQuantityCombo
          taxes
          return
          isFast
          isGift
          variantJSON
          isCombo
          comboID
          promotion {
            id
            companyID
            countryID
            type
            name
            dateInit
            dateEnd
            fixedAmount
            priceCombo
            percentageAmount
            amountMinPurchase
            applyListProduct
            applyAmountMinAllPurchase
            applyAmountMinProducts
            applySpecificProducts
            applyamountMin
            applyLimit
            applySpecificLocation
            applySpecificDaysTimes
            applycumulative
            applyListCustomer
            applyAnonymousSales
            finishAccordingBudget
            finishAccordingBudgetValue
            applyMaxAmountForSale
            applyMaxAmountForSaleValue
            applyMaxAmountForCustomer
            applyMaxAmountForCustomerValue
            applyTransactionsMaxForCustomer
            applyTransactionsMaxForCustomerValue
            isTimeUnlimited
            taxes
            state
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      shipments {
        items {
          id
          type
          status
          fromLocation {
            realName
          }
          tracking {
            items {
              status
              createdAt
            }
          }
          address {
            address
          }
          variants(limit: 500) {
            items {
              id
            }
          }
        }
      }
      canceled
      invoicingElectronic
      receiptNumber
      receiptPrefix
      receiptObservations
      withholdingArray
      createdAtLocal
      createdAt
      updatedAt
      countryID
    }
  }
`;

export const searchOrders = /* GraphQL */ `
  query SearchOrders(
    $filter: SearchableOrderFilterInput
    $sort: [SearchableOrderSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableOrderAggregationInput]
  ) {
    searchOrders(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        status
        subTotalOne
        totalDiscount
        subTotalTwo
        totalTax
        totalWithholding
        totalPrice
        paidPrice
        tip
        currency
        locationID
        companyID
        userID
        userJSON
        cashierID
        saleChannel
        paymentConfirm
        deliveryConfirm
        customerID
        createdAtLocal
        createdAt
        updatedAt
        countryID
        canceled
        invoicingElectronic
        receiptPrefix
        receiptNumber
        receiptObservations
        taxType
        withholdingArray
        pointsToRedeem
        discountSelected
        saleChannelID
        providerOrderNumber
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;

export const saleTabsByLocationID = /* GraphQL */ `
  query SaleTabsByLocationID(
    $locationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSaleTabsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    saleTabsByLocationID(
      locationID: $locationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        locationID
        title
        closable
        orderID
        invoicingData
        shoppingCart
        shoppingCartTran
        shoppingCartSummary
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const orderVariantsByOrderIDAndCompanyID = /* GraphQL */ `
  query OrderVariantsByOrderIDAndCompanyID(
    $orderID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderVariantsByOrderIDAndCompanyID(
      orderID: $orderID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        orderID
        variantID
        salePrice
        discount
        taxValue
        finalPrice
        taxes
        return
        reasonReturn
        methodReturn
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      companyID
      name
      email
      invoicing
      phoneNumber
      governmentID
      countryID
      createdAt
      updatedAt
    }
  }
`;

export const ordersByCustomerID = /* GraphQL */ `
  query OrdersByCustomerID(
    $customerID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByCustomerID(
      customerID: $customerID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subTotalOne
        totalDiscount
        subTotalTwo
        totalTax
        totalPrice
        paidPrice
        currency
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationJSON
        companyID
        userID
        user {
          id
          name
          familyName
          email
          phoneNumber
          role
          status
          color
          isConnected
          connectedStore
          companyID
          countryID
          createdAt
          updatedAt
        }
        userJSON
        cashierID
        cashier {
          id
          name
          locationID
          companyID
          countryID
          createdAt
          updatedAt
        }
        cashierJSON
        saleChannel
        paymentMethod {
          items {
            value
            paymentMethod {
              id
              name
            }
          }
        }
        paymentConfirm
        deliveryConfirm
        customerID
        customer {
          id
          companyID
          name
          email
          phoneNumber
          governmentID
          countryID
          createdAt
          updatedAt
        }
        variants {
          items {
            finalPrice
            return
            userJSON
            variantJSON
            variantID
            variant {
              id
              productName
              name
              sku
              type
            }
          }
        }
        createdAtLocal
        createdAt
        updatedAt
        countryID
        canceled
        receiptPrefix
        receiptNumber
        receiptObservations
        taxType
      }
      nextToken
    }
  }
`;

export const variantUsersByVariantID = /* GraphQL */ `
  query VariantUsersByVariantID(
    $variantID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelVariantUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    variantUsersByVariantID(
      variantID: $variantID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        variantID
        variant {
          id
          name
          productName
          img
          barcode
          sku
          defaultPrice
          inventory {
            items {
              id
              price
              stockLevel
              stockAlert
              variantID
              locationID
              location {
                id
                name
              }
            }
          }
          type
          companyID
          productID
          countryID
          createdAt
          updatedAt
        }
        userID
        user {
          id
          name
          familyName
          email
          phoneNumber
          role
          status
          color
          isConnected
          connectedStore
          companyID
          countryID
          createdAt
          updatedAt
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const variantUsersByUserID = /* GraphQL */ `
  query VariantUsersByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelVariantUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    variantUsersByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        variantID
        variant {
          id
          name
          productName
          img
          barcode
          inventory {
            items {
              id
              price
              stockLevel
              stockAlert
              variantID
              locationID
              location {
                id
                name
              }
            }
          }
          sku
          defaultPrice
          type
          companyID
          productID
          countryID
          createdAt
          updatedAt
        }
        userID
        user {
          id
          name
          familyName
          email
          phoneNumber
          role
          status
          color
          isConnected
          connectedStore
          companyID
          countryID
          createdAt
          updatedAt
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const journalsByLocationIDAndCreatedAtLocal = /* GraphQL */ `
  query JournalsByLocationIDAndCreatedAtLocal(
    $locationID: ID!
    $createdAtLocal: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelJournalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    journalsByLocationIDAndCreatedAtLocal(
      locationID: $locationID
      createdAtLocal: $createdAtLocal
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        recordValue
        currency
        recordType
        locationID
        locationJSON
        cashierID
        cashierJSON
        userID
        userJSON
        paymentMethodID
        description
        variantID
        variantJSON
        createdAtLocal
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const journalsByCashierIDAndCreatedAtLocal = /* GraphQL */ `
  query JournalsByCashierIDAndCreatedAtLocal(
    $cashierID: ID!
    $createdAtLocal: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelJournalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    journalsByCashierIDAndCreatedAtLocal(
      cashierID: $cashierID
      createdAtLocal: $createdAtLocal
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        recordValue
        currency
        recordType
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationJSON
        cashierID
        cashierJSON
        userID
        userJSON
        paymentMethodID
        description
        createdAtLocal
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const cashierBalancesByCashierIDAndCreatedAtLocal = /* GraphQL */ `
  query CashierBalancesByCashierIDAndCreatedAtLocal(
    $cashierID: ID!
    $createdAtLocal: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCashierBalanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cashierBalancesByCashierIDAndCreatedAtLocal(
      cashierID: $cashierID
      createdAtLocal: $createdAtLocal
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        balanceType
        systemBalance
        countedBalance
        actionType
        currency
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationJSON
        cashierID
        cashier {
          id
          name
          locationID
          companyID
          countryID
          createdAt
          updatedAt
        }
        cashierJSON
        userID
        user {
          id
          name
          familyName
          email
          phoneNumber
          role
          status
          color
          isConnected
          connectedStore
          companyID
          countryID
          createdAt
          updatedAt
        }
        userJSON
        paymentMethodID
        paymentMethod {
          id
          name
          description
          active
          icon
          countryID
          createdAt
          updatedAt
        }
        createdAtLocal
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const cashierBalancesByLocationIDAndCreatedAtLocal = /* GraphQL */ `
  query CashierBalancesByLocationIDAndCreatedAtLocal(
    $locationID: ID!
    $createdAtLocal: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCashierBalanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cashierBalancesByLocationIDAndCreatedAtLocal(
      locationID: $locationID
      createdAtLocal: $createdAtLocal
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        balanceType
        systemBalance
        countedBalance
        actionType
        currency
        locationID
        location {
          id
          name
          realName
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationJSON
        cashierID
        cashier {
          id
          name
          locationID
          companyID
          countryID
          createdAt
          updatedAt
        }
        cashierJSON
        userID
        user {
          id
          name
          familyName
          email
          phoneNumber
          role
          status
          color
          isConnected
          connectedStore
          companyID
          countryID
          createdAt
          updatedAt
        }
        userJSON
        paymentMethodID
        paymentMethod {
          id
          name
          description
          active
          icon
          countryID
          createdAt
          updatedAt
        }
        createdAtLocal
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const searchCashierBalances = /* GraphQL */ `
  query SearchCashierBalances(
    $filter: SearchableCashierBalanceFilterInput
    $sort: [SearchableCashierBalanceSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCashierBalanceAggregationInput]
  ) {
    searchCashierBalances(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        companyID
        balanceType
        systemBalance
        countedBalance
        actionType
        currency
        locationID
        location {
          id
          name
          realName
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationJSON
        cashierID
        cashier {
          id
          name
          locationID
          companyID
          countryID
          mainPrint
          secondaryPrint
          createdAt
          updatedAt
        }
        cashierJSON
        userID
        user {
          id
          name
          familyName
          email
          phoneNumber
          role
          status
          color
          isConnected
          connectedStore
          companyID
          countryID
          createdAt
          updatedAt
        }
        userJSON
        paymentMethodID
        paymentMethod {
          id
          name
          description
          active
          icon
          countryID
          createdAt
          updatedAt
        }
        createdAtLocal
        countryID
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const cashiersByLocationID = /* GraphQL */ `
  query CashiersByLocationID(
    $locationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCashierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cashiersByLocationID(
      locationID: $locationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        mainPrint
        secondaryPrint
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        companyID
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listPlans = /* GraphQL */ `
  query ListPlans(
    $filter: ModelPlansFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        countryID
        country {
          id
          name
          language
          currency
          phonePrefix
          code
          createdAt
          updatedAt
        }
        name
        monthlyPrice
        currency
        tax
        users
        locations
        variants
        revenue
        periods
        published
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const billingsByCompanyIDAndStartDate = /* GraphQL */ `
  query BillingsByCompanyIDAndStartDate(
    $companyID: ID!
    $startDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBillingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    billingsByCompanyIDAndStartDate(
      companyID: $companyID
      startDate: $startDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        finalPrice
        currency
        startDate
        endDate
        period
        planDiscount
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          mainCountryID
          createdAt
          updatedAt
        }
        planID
        plan {
          id
          countryID
          name
          monthlyPrice
          currency
          tax
          users
          locations
          variants
          revenue
          periods
          published
          createdAt
          updatedAt
        }
        active
        codeID
        countryID
        firstTime
        trial
        paymentReceived
        stripeSubscriptionID
        stripeAccountID
        stripePriceID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const codesByCode = /* GraphQL */ `
  query CodesByCode(
    $code: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    codesByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        type
        discount
        commission
        partnerID
        partner {
          id
          type
          name
          familyName
          email
          phoneNumber
          companyName
          active
          countryID
          createdAt
          updatedAt
        }
        active
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const usersByEmail = /* GraphQL */ `
  query UsersByEmail(
    $email: AWSEmail!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        familyName
        email
        phoneNumber
        role
        status
        color
        isConnected
        connectedStore
        companyID
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const emailSendersByCountryID = /* GraphQL */ `
  query EmailSendersByCountryID(
    $countryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmailSenderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    emailSendersByCountryID(
      countryID: $countryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        email
        state
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const creditPackagesByCountryID = /* GraphQL */ `
  query CreditPackagesByCountryID(
    $countryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCreditPackageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    creditPackagesByCountryID(
      countryID: $countryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        countryID
        name
        price
        tax
        countCredit
        currency
        published
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const creditsByCompanyIDAndCreatedAt = /* GraphQL */ `
  query CreditsByCompanyIDAndCreatedAt(
    $companyID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCreditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    creditsByCompanyIDAndCreatedAt(
      companyID: $companyID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        finalBalance
        movementType
        movementValue
        movementDescription
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          phoneNumber
          mainEmail
          mainName
          superAdminID
          mainCountryID
          isNew
          saleObjective
          crmID
          createdAt
          updatedAt
        }
        createdAt
        firstTime
        updatedAt
      }
      nextToken
    }
  }
`;

export const validateEmailsByEmailAndCreatedAt = /* GraphQL */ `
  query ValidateEmailsByEmailAndCreatedAt(
    $email: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelValidateEmailFilterInput
    $limit: Int
    $nextToken: String
  ) {
    validateEmailsByEmailAndCreatedAt(
      email: $email
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        code
        validate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const creditConversorsByCountryIDAndTypeEvent = /* GraphQL */ `
  query CreditConversorsByCountryIDAndTypeEvent(
    $countryID: ID!
    $typeEvent: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCreditConversorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    creditConversorsByCountryIDAndTypeEvent(
      countryID: $countryID
      typeEvent: $typeEvent
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        countryID
        typeEvent
        valueCredit
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const vendorsByCompanyIDAndName = /* GraphQL */ `
  query VendorsByCompanyIDAndName(
    $companyID: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vendorsByCompanyIDAndName(
      companyID: $companyID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        identificationNumber
        bankAccountNumber
        typeBankAccount
        bankName
        contactName
        contactEmail
        contactPhoneNumber
        vendorAddress
        vendorCountry
        vendorCity
        countryID
        companyID
        products {
          nextToken
        }
        purchaseOrders {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const vendorsByCountryID = /* GraphQL */ `
  query VendorsByCountryID(
    $countryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelVendorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vendorsByCountryID(
      countryID: $countryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        identificationNumber
        bankAccountNumber
        typeBankAccount
        bankName
        contactName
        contactEmail
        contactPhoneNumber
        vendorAddress
        vendorCountry
        vendorCity
        countryID
        companyID
        products {
          nextToken
        }
        purchaseOrders {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const purchaseOrdersByCountryID = /* GraphQL */ `
  query PurchaseOrdersByCountryID(
    $countryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrdersByCountryID(
      countryID: $countryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        countryID
        companyID
        addressDelivery
        dateDelivery
        taxMode
        vendorID
        vendorJSON
        vendor {
          id
          name
          identificationNumber
          bankAccountNumber
          typeBankAccount
          bankName
          contactName
          contactEmail
          contactPhoneNumber
          vendorAddress
          vendorCountry
          vendorCity
          countryID
          companyID
          createdAt
          updatedAt
        }
        products {
          items {
            id
            companyID
            purchaseOrderID
            productID
            productJSON
            variantJSON
            variantID
            productPrice
            discount
            taxID
            taxJSON
            quantity
            receivedQuantity
            paymentType
            total
            createdAt
            updatedAt
          }
          nextToken
          __typename
        }
        subTotalOne
        totalDiscount
        subTotalTwo
        totalTax
        totalPrice
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const purchaseOrdersByCompanyIDAndCreatedAt = /* GraphQL */ `
  query PurchaseOrdersByCompanyIDAndCreatedAt(
    $companyID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrdersByCompanyIDAndCreatedAt(
      companyID: $companyID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        countryID
        companyID
        addressDelivery
        dateDelivery
        taxMode
        vendorID
        vendorJSON
        invoiced
        vendor {
          id
          name
          identificationNumber
          bankAccountNumber
          typeBankAccount
          bankName
          contactName
          contactEmail
          contactPhoneNumber
          vendorAddress
          vendorCountry
          vendorCity
          countryID
          companyID
          createdAt
          updatedAt
        }
        products {
          items {
            id
            companyID
            purchaseOrderID
            productID
            productJSON
            variantJSON
            variantID
            productPrice
            discount
            taxID
            taxJSON
            quantity
            receivedQuantity
            paymentType
            total
            createdAt
            updatedAt
          }
          nextToken
          __typename
        }
        targetLocation {
          id
          name
          realName
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          city {
            name
            timeZone
          }
          cashiers {
            items {
              id
              name
            }
          }
          companyID
          company {
            id
            companyName
            annualIncome
            numberEmployees
            businessType
            companyLogo
            companyWebpage
            superAdminID
            createdAt
            updatedAt
          }
          users {
            items {
              user {
                id
                familyName
                name
                email
              }
            }
          }
          countryID
          taxes {
            items {
              id
              taxID
              tax {
                id
                name
                percentage
              }
            }
          }
          createdAt
          updatedAt
        }
        subTotalOne
        totalDiscount
        subTotalTwo
        totalTax
        totalPrice
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const purchaseOrdersByCompanyIDAndId = /* GraphQL */ `
  query PurchaseOrdersByCompanyIDAndId(
    $companyID: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrdersByCompanyIDAndId(
      companyID: $companyID
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        countryID
        companyID
        addressDelivery
        dateDelivery
        taxMode
        vendorID
        vendorJSON
        vendor {
          id
          name
          identificationNumber
          bankAccountNumber
          typeBankAccount
          bankName
          contactName
          contactEmail
          contactPhoneNumber
          vendorAddress
          vendorCountry
          vendorCity
          countryID
          companyID
          createdAt
          updatedAt
        }
        products {
          items {
            id
            companyID
            purchaseOrderID
            productID
            productJSON
            variantJSON
            variantID
            productPrice
            discount
            taxID
            taxJSON
            quantity
            receivedQuantity
            paymentType
            total
            createdAt
            updatedAt
          }
          nextToken
          __typename
        }
        subTotalOne
        totalDiscount
        subTotalTwo
        totalTax
        totalPrice
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const vendorProductsByVendorIDAndCompanyID = /* GraphQL */ `
  query VendorProductsByVendorIDAndCompanyID(
    $vendorID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vendorProductsByVendorIDAndCompanyID(
      vendorID: $vendorID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        vendorID
        vendor {
          id
          name
          identificationNumber
          bankAccountNumber
          typeBankAccount
          bankName
          contactName
          contactEmail
          contactPhoneNumber
          vendorAddress
          vendorCountry
          vendorCity
          countryID
          companyID
          createdAt
          updatedAt
        }
        productID
        productJSON
        product {
          id
          type
          name
          categoryID
          category {
            name
          }
          variants {
            items {
              id
              name
              barcode
              sku
            }
            nextToken
          }
          img
          color
          units
          minDuration
          description
          companyID
          countryID
          createdAt
          updatedAt
        }
        productPrice
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const purchaseOrdersByVendorIDAndId = /* GraphQL */ `
  query PurchaseOrdersByVendorIDAndId(
    $vendorID: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrdersByVendorIDAndId(
      vendorID: $vendorID
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        countryID
        companyID
        addressDelivery
        dateDelivery
        taxMode
        vendorID
        vendor {
          id
          name
          identificationNumber
          bankAccountNumber
          typeBankAccount
          bankName
          contactName
          contactEmail
          contactPhoneNumber
          vendorAddress
          vendorCountry
          vendorCity
          countryID
          companyID
          createdAt
          updatedAt
        }
        products {
          items {
            id
            companyID
            purchaseOrderID
            productID
            productJSON
            variantJSON
            variantID
            productPrice
            discount
            taxID
            taxJSON
            quantity
            receivedQuantity
            paymentType
            total
            createdAt
            updatedAt
          }
          nextToken
          __typename
        }
        subTotalOne
        totalDiscount
        subTotalTwo
        totalTax
        totalPrice
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const purchaseOrderProductsByPurchaseOrderIDAndCompanyID = /* GraphQL */ `
  query PurchaseOrderProductsByPurchaseOrderIDAndCompanyID(
    $purchaseOrderID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrderProductsByPurchaseOrderIDAndCompanyID(
      purchaseOrderID: $purchaseOrderID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        purchaseOrderID
        purchaseOrder {
          id
          status
          countryID
          companyID
          addressDelivery
          targetLocationID
          dateDelivery
          realDateDelivery
          observations
          fileUrl
          taxMode
          vendorID
          vendorJSON
          invoiced
          purchaseOrderPaymentMethods {
            items {
              id
              value
              isReturn
              treasuryAccountID
              createdAt
            }
          }
          paymentType
          vendor {
            id
            name
            identificationNumber
            bankAccountNumber
            typeBankAccount
            bankName
            contactName
            contactEmail
            contactPhoneNumber
            vendorAddress
            vendorCountry
            vendorCity
            countryID
            companyID
            createdAt
            updatedAt
          }
          targetLocation {
            id
            name
            realName
            locationType
            country
            cityID
            address
            postalCode
            lon
            lat
            active
            inStore
            pickCollect
            deliveries
            img
            city {
              name
              timeZone
            }
            cashiers {
              items {
                id
                name
              }
            }
            companyID
            company {
              id
              companyName
              annualIncome
              numberEmployees
              businessType
              companyLogo
              companyWebpage
              superAdminID
              createdAt
              updatedAt
            }
            users {
              items {
                user {
                  id
                  familyName
                  name
                  email
                }
              }
            }
            countryID
            taxes {
              items {
                id
                taxID
                tax {
                  id
                  name
                  percentage
                }
              }
            }
            createdAt
            updatedAt
          }
          subTotalOne
          totalDiscount
          subTotalTwo
          totalTax
          totalPrice
          paymentType
          paymentMoment
          treasuryAccountID
          paymentDate
          paidAmount
          paymentCompleted
          createdAt
          updatedAt
          __typename
        }
        productID
        product {
          id
          type
          name
          categoryID
          img
          color
          units
          minDuration
          isPerishable
          description
          companyID
          countryID
          createdAt
          updatedAt
          __typename
        }
        productJSON
        variantJSON
        variantID
        variant {
          id
          name
          productName
          img
          barcode
          sku
          defaultPrice
          type
          companyID
          productID
          countryID
          inventory {
            items {
              id
              price
              stockLevel
              stockAlert
              variantID
              locationID
              location {
                id
                name
              }
            }
          }
          createdAt
          updatedAt
          __typename
        }
        productPrice
        discount
        taxID
        taxJSON
        quantity
        receivedQuantity
        paymentType
        total
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getVendor = /* GraphQL */ `
  query GetVendor($id: ID!) {
    getVendor(id: $id) {
      id
      name
      identificationNumber
      bankAccountNumber
      typeBankAccount
      bankName
      contactName
      contactEmail
      contactPhoneNumber
      vendorAddress
      vendorCountry
      vendorCity
      countryID
      companyID
      products {
        nextToken
        __typename
      }
      purchaseOrders {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const vendorProductsByProductIDAndCompanyID = /* GraphQL */ `
  query VendorProductsByProductIDAndCompanyID(
    $productID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vendorProductsByProductIDAndCompanyID(
      productID: $productID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        vendorID
        vendor {
          id
          name
          identificationNumber
          bankAccountNumber
          typeBankAccount
          bankName
          contactName
          contactEmail
          contactPhoneNumber
          vendorAddress
          vendorCountry
          vendorCity
          countryID
          companyID
          createdAt
          updatedAt
        }
        productID
        product {
          id
          type
          name
          categoryID
          img
          color
          units
          minDuration
          description
          companyID
          countryID
          createdAt
          updatedAt
        }
        productPrice
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listVendors = /* GraphQL */ `
  query ListVendors(
    $filter: ModelVendorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendors(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        identificationNumber
        bankAccountNumber
        typeBankAccount
        bankName
        contactName
        contactEmail
        contactPhoneNumber
        vendorAddress
        vendorCountry
        vendorCity
        countryID
        companyID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const purchaseOrderProductsByProductIDAndCompanyID = /* GraphQL */ `
  query PurchaseOrderProductsByProductIDAndCompanyID(
    $productID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrderProductsByProductIDAndCompanyID(
      productID: $productID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        purchaseOrderID
        productID
        productJSON
        variantJSON
        variantID
        productPrice
        discount
        taxID
        taxJSON
        quantity
        receivedQuantity
        paymentType
        total
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const inventoryBatchesByCompanyIDAndCreatedAt = /* GraphQL */ `
  query InventoryBatchesByCompanyIDAndCreatedAt(
    $companyID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryBatchesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryBatchesByCompanyIDAndCreatedAt(
      companyID: $companyID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        purchaseOrderProductsID
        purchaseOrderProducts {
          id
          companyID
          purchaseOrderID
          purchaseOrder {
            id
            status
            countryID
            companyID
            addressDelivery
            dateDelivery
            realDateDelivery
            taxMode
            vendorID
            vendorJSON
            subTotalOne
            totalDiscount
            subTotalTwo
            totalTax
            totalPrice
            createdAt
            updatedAt
            __typename
          }
        }
        inventoryID
        unitsReceived
        usedUnits
        closedState
        costUnit
        expirationDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const inventoryBatchesByCompanyIDAndExpirationDate = /* GraphQL */ `
  query InventoryBatchesByCompanyIDAndExpirationDate(
    $companyID: ID!
    $expirationDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryBatchesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryBatchesByCompanyIDAndExpirationDate(
      companyID: $companyID
      expirationDate: $expirationDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        purchaseOrderProductsID
        purchaseOrderProducts {
          id
          companyID
          purchaseOrderID
          purchaseOrder {
            id
            status
            countryID
            companyID
            addressDelivery
            dateDelivery
            realDateDelivery
            taxMode
            vendorID
            vendorJSON
            subTotalOne
            totalDiscount
            subTotalTwo
            totalTax
            totalPrice
            createdAt
            updatedAt
            __typename
          }
        }
        inventoryID
        locationID
        location {
          id
          name
          realName
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        variantID
        variant {
          id
          name
          productName
          img
          barcode
          sku
          defaultPrice
          type
          searchHelper
          companyID
          productID
          countryID
          createdAt
          updatedAt
        }
        unitsReceived
        usedUnits
        closedState
        costUnit
        expirationDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const inventoryBatchesByInventoryIDAndCreatedAt = /* GraphQL */ `
  query InventoryBatchesByInventoryIDAndCreatedAt(
    $inventoryID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryBatchesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryBatchesByInventoryIDAndCreatedAt(
      inventoryID: $inventoryID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        productionOrderVariantsID
        purchaseOrderProductsID

        purchaseOrderProducts {
          id
          companyID
          purchaseOrderID
          purchaseOrder {
            id
            status
            countryID
            companyID
            addressDelivery
            dateDelivery
            realDateDelivery
            taxMode
            vendorID
            vendorJSON
            subTotalOne
            totalDiscount
            subTotalTwo
            totalTax
            totalPrice
            createdAt
            updatedAt
            __typename
          }
        }
        inventoryID
        unitsReceived
        usedUnits
        closedState
        costUnit
        expirationDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const inventoryBatchesByInventoryIDAndExpirationDate = /* GraphQL */ `
  query InventoryBatchesByInventoryIDAndExpirationDate(
    $inventoryID: ID!
    $expirationDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryBatchesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryBatchesByInventoryIDAndExpirationDate(
      inventoryID: $inventoryID
      expirationDate: $expirationDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID

        productionOrderVariantsID
        purchaseOrderProductsID
        purchaseOrderProducts {
          id
          companyID
          purchaseOrderID
          purchaseOrder {
            id
            status
            countryID
            companyID
            addressDelivery
            dateDelivery
            realDateDelivery
            taxMode
            vendorID
            vendorJSON
            subTotalOne
            totalDiscount
            subTotalTwo
            totalTax
            totalPrice
            createdAt
            updatedAt
            __typename
          }
        }
        inventoryID
        unitsReceived
        usedUnits
        closedState
        costUnit
        expirationDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPurchaseOrderProducts = /* GraphQL */ `
  query GetPurchaseOrderProducts($id: ID!) {
    getPurchaseOrderProducts(id: $id) {
      id
      companyID
      purchaseOrderID
      purchaseOrder {
        id
        status
        countryID
        companyID
        addressDelivery
        dateDelivery
        realDateDelivery
        taxMode
        vendorID
        vendor {
          id
          name
        }
        vendorJSON
        subTotalOne
        totalDiscount
        subTotalTwo
        totalTax
        totalPrice
        createdAt
        updatedAt
        __typename
      }
      productID
      product {
        id
        type
        name
        categoryID
        img
        color
        units
        minDuration
        description
        isPerishable
        companyID
        countryID
        createdAt
        updatedAt
        __typename
      }
      productJSON
      variantJSON
      variantID
      variant {
        id
        name
        productName
        img
        barcode
        sku
        defaultPrice
        inventory {
          items {
            id
            price
            stockLevel
            stockAlert
            variantID
            locationID
            location {
              id
              name
            }
          }
        }
        type
        companyID
        productID
        countryID
        createdAt
        updatedAt
        __typename
      }
      productPrice
      discount
      taxID
      taxJSON
      taxValue
      discountValue
      quantity
      receivedQuantity
      paymentType
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrderVariants = /* GraphQL */ `
  query ListOrderVariants(
    $filter: ModelOrderVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderVariants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyID
        orderID
        order {
          id
          subTotalOne
          totalDiscount
          subTotalTwo
          totalTax
          totalPrice
          paidPrice
          currency
          locationID
          locationJSON
          companyID
          userID
          userJSON
          cashierID
          cashierJSON
          saleChannel
          paymentConfirm
          deliveryConfirm
          customerID
          createdAtLocal
          createdAt
          updatedAt
          countryID
          canceled
          receiptPrefix
          receiptNumber
          receiptObservations
          taxType
        }
        variantID
        variant {
          id
          name
          productName
          img
          barcode
          sku
          defaultPrice
          type
          searchHelper
          companyID
          productID
          countryID
          createdAt
          updatedAt
        }
        variantJSON
        salePrice
        discount
        taxValue
        finalPrice
        taxes
        userID
        user {
          id
          name
          familyName
          email
          phoneNumber
          role
          status
          color
          isConnected
          connectedStore
          companyID
          countryID
          createdAt
          updatedAt
        }
        userJSON
        return
        reasonReturn
        methodReturn
        vendorCost
        vendorID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const orderVariantsByCompanyIDAndCreatedAt = /* GraphQL */ `
  query OrderVariantsByCompanyIDAndCreatedAt(
    $companyID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderVariantsByCompanyIDAndCreatedAt(
      companyID: $companyID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        orderID
        variantID
        variantJSON
        createdAt
        salePrice
        discount
        taxValue
        finalPrice
        taxes
        userID
        quantity
        userJSON
        return
        reasonReturn
        methodReturn
        vendorCost
        vendorID
        vendorJSON
        vendor {
          id
          name
        }
        inventoryBatches {
          items {
            id
            usedQuantity
            inventoryBatchesID
            inventoryBatches {
              id
              purchaseOrderProductsID
              costUnit
            }
          }
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getInventoryBatches = /* GraphQL */ `
  query GetInventoryBatches($id: ID!) {
    getInventoryBatches(id: $id) {
      id
      companyID
      purchaseOrderProductsID
      purchaseOrderProducts {
        id
        companyID
        purchaseOrderID
        purchaseOrder {
          id
          status
          countryID
          companyID
          addressDelivery
          dateDelivery
          realDateDelivery
          taxMode
          vendorID
          vendorJSON
          subTotalOne
          totalDiscount
          subTotalTwo
          totalTax
          totalPrice
          observations
          pdf
          createdAt
          updatedAt
          fileUrl
        }
        productID
      }
      productionOrderVariantsID
      inventoryID
      locationID
      expirationDate
      createdAt
      file
      updatedAt
    }
  }
`;

/*
inventoryBatches {
  id
  companyID
  purchaseOrderProductsID
  purchaseOrderProducts {
    id
    companyID
    purchaseOrderID
    purchaseOrder {
      id
      status
      countryID
      companyID
      addressDelivery
      dateDelivery
      realDateDelivery
      taxMode
      vendorID
      vendor {
        id
        name
        identificationNumber
        bankAccountNumber
        typeBankAccount
        bankName
        contactName
        contactEmail
        contactPhoneNumber
        vendorAddress
        vendorCountry
        vendorCity
        countryID
        companyID
        createdAt
        updatedAt
      }
      vendorJSON
      subTotalOne
      totalDiscount
      subTotalTwo
      totalTax
      totalPrice
      createdAt
      updatedAt
      __typename
    }
  }
  productionOrderVariantsID
  inventoryID
  locationID
  variantID
  unitsReceived
  usedUnits
  closedState
  costUnit
  expirationDate
  createdAt
  file
  updatedAt
}
*/
export const rawMaterialsByCompanyIDAndBarcode = /* GraphQL */ `
  query RawMaterialsByCompanyIDAndBarcode(
    $companyID: ID!
    $barcode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRawMaterialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rawMaterialsByCompanyIDAndBarcode(
      companyID: $companyID
      barcode: $barcode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        barcode
        sku
        searchHelper
        isPerishable
        description
        units
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          phoneNumber
          mainEmail
          mainName
          superAdminID
          mainCountryID
          isNew
          saleObjective
          crmID
          createdAt
          updatedAt
        }
        rawMaterialInventory {
          items {
            id
            stockLevel
            stockAlert
            companyID
            rawMaterialID
            locationID
            location {
              id
              name
            }
            countryID
            createdAt
            updatedAt
          }
          nextToken
        }
        purchaseOrderRawMaterial {
          nextToken
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const rawMaterialsByCompanyIDAndSearchHelper = /* GraphQL */ `
  query RawMaterialsByCompanyIDAndSearchHelper(
    $companyID: ID!
    $searchHelper: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRawMaterialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rawMaterialsByCompanyIDAndSearchHelper(
      companyID: $companyID
      searchHelper: $searchHelper
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        barcode
        sku
        searchHelper
        isPerishable
        description
        units
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          phoneNumber
          mainEmail
          mainName
          superAdminID
          mainCountryID
          isNew
          saleObjective
          crmID
          createdAt
          updatedAt
        }
        rawMaterialInventory {
          items {
            id
            stockLevel
            stockAlert
            companyID
            rawMaterialID
            locationID
            location {
              id
              name
            }
            countryID
            createdAt
            updatedAt
          }
          nextToken
        }
        purchaseOrderRawMaterial {
          nextToken
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const vendorRawMaterialsByVendorIDAndCompanyID = /* GraphQL */ `
  query VendorRawMaterialsByVendorIDAndCompanyID(
    $vendorID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorRawMaterialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vendorRawMaterialsByVendorIDAndCompanyID(
      vendorID: $vendorID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        vendorID
        vendor {
          id
          name
          identificationNumber
          bankAccountNumber
          typeBankAccount
          bankName
          contactName
          contactEmail
          contactPhoneNumber
          vendorAddress
          vendorCountry
          vendorCity
          countryID
          companyID
          createdAt
          updatedAt
        }
        rawMaterialID
        rawMaterial {
          id
          name
          barcode
          sku
          searchHelper
          isPerishable
          description
          units
          companyID
          countryID
          createdAt
          updatedAt
        }
        rawMaterialJSON
        rawMaterialPrice
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const vendorRawMaterialsByRawMaterialIDAndCompanyID = /* GraphQL */ `
  query VendorRawMaterialsByRawMaterialIDAndCompanyID(
    $rawMaterialID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorRawMaterialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vendorRawMaterialsByRawMaterialIDAndCompanyID(
      rawMaterialID: $rawMaterialID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        vendorID
        vendor {
          id
          name
          identificationNumber
          bankAccountNumber
          typeBankAccount
          bankName
          contactName
          contactEmail
          contactPhoneNumber
          vendorAddress
          vendorCountry
          vendorCity
          countryID
          companyID
          createdAt
          updatedAt
        }
        rawMaterialID
        rawMaterial {
          id
          name
          barcode
          sku
          searchHelper
          isPerishable
          description
          units
          companyID
          countryID
          createdAt
          updatedAt
        }
        rawMaterialJSON
        rawMaterialPrice
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getRawMaterialInventory = /* GraphQL */ `
  query GetRawMaterialInventory($id: ID!) {
    getRawMaterialInventory(id: $id) {
      id
      stockLevel
      stockAlert
      companyID
      rawMaterialID
      rawMaterial {
        id
        name
        barcode
        sku
        searchHelper
        isPerishable
        description
        units
        companyID
        countryID
        createdAt
        updatedAt
        __typename
      }
      locationID
      location {
        id
        name
        locationType
        country
        cityID
        city {
          id
          timeZone
        }
        address
        postalCode
        lon
        lat
        active
        inStore
        pickCollect
        deliveries
        img
        companyID
        countryID
        createdAt
        updatedAt
        __typename
      }
      countryID
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const getRawMaterial = /* GraphQL */ `
  query GetRawMaterial($id: ID!) {
    getRawMaterial(id: $id) {
      id
      name
      barcode
      sku
      searchHelper
      isPerishable
      description
      units
      companyID
      vendorRawMaterial {
        items {
          id
          companyID
          vendorID
          rawMaterialID
          rawMaterialJSON
          rawMaterialPrice
          createdAt
          updatedAt
        }
        nextToken
      }
      countryID
      createdAt
      updatedAt
    }
  }
`;
export const rawMaterialInventoriesByLocationIDAndRawMaterialID = /* GraphQL */ `
  query RawMaterialInventoriesByLocationIDAndRawMaterialID(
    $locationID: ID!
    $rawMaterialID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRawMaterialInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rawMaterialInventoriesByLocationIDAndRawMaterialID(
      locationID: $locationID
      rawMaterialID: $rawMaterialID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        stockLevel
        stockAlert
        companyID
        rawMaterialID
        rawMaterial {
          id
          name
          barcode
          sku
          searchHelper
          isPerishable
          description
          units
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const rawMaterialInventoriesByRawMaterialIDAndLocationID = /* GraphQL */ `
  query RawMaterialInventoriesByRawMaterialIDAndLocationID(
    $rawMaterialID: ID!
    $locationID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRawMaterialInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rawMaterialInventoriesByRawMaterialIDAndLocationID(
      rawMaterialID: $rawMaterialID
      locationID: $locationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        stockLevel
        stockAlert
        companyID
        rawMaterialID
        rawMaterial {
          id
          name
          barcode
          sku
          searchHelper
          isPerishable
          description
          units
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        countryID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const rawMaterialInventoryBatchesByRawMaterialInventoryIDAndCreatedAt = /* GraphQL */ `
  query RawMaterialInventoryBatchesByRawMaterialInventoryIDAndCreatedAt(
    $rawMaterialInventoryID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRawMaterialInventoryBatchesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rawMaterialInventoryBatchesByRawMaterialInventoryIDAndCreatedAt(
      rawMaterialInventoryID: $rawMaterialInventoryID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        purchaseOrderRawMaterialID
        purchaseOrderRawMaterial {
          id
          companyID
          purchaseOrderID
          rawMaterialID
          rawMaterialJSON
          productPrice
          discount
          taxID
          taxJSON
          taxValue
          discountValue
          quantity
          receivedQuantity
          paymentType
          total
          createdAt
          updatedAt
        }
        rawMaterialInventoryID
        unitsReceived
        usedUnits
        closedState
        costUnit
        expirationDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const rawMaterialInventoryBatchesByRawMaterialInventoryIDAndExpirationDate = /* GraphQL */ `
  query RawMaterialInventoryBatchesByRawMaterialInventoryIDAndExpirationDate(
    $rawMaterialInventoryID: ID!
    $expirationDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRawMaterialInventoryBatchesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rawMaterialInventoryBatchesByRawMaterialInventoryIDAndExpirationDate(
      rawMaterialInventoryID: $rawMaterialInventoryID
      expirationDate: $expirationDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        purchaseOrderRawMaterialID
        purchaseOrderRawMaterial {
          id
          companyID
          purchaseOrderID
          rawMaterialID
          rawMaterialJSON
          productPrice
          discount
          taxID
          taxJSON
          taxValue
          discountValue
          quantity
          receivedQuantity
          paymentType
          total
          createdAt
          updatedAt
        }
        rawMaterialInventoryID
        unitsReceived
        usedUnits
        closedState
        costUnit
        expirationDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const rawMaterialInventoryBatchesByCompanyIDAndCreatedAt = /* GraphQL */ `
  query RawMaterialInventoryBatchesByCompanyIDAndCreatedAt(
    $companyID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRawMaterialInventoryBatchesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rawMaterialInventoryBatchesByCompanyIDAndCreatedAt(
      companyID: $companyID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        purchaseOrderRawMaterialID
        purchaseOrderRawMaterial {
          id
          companyID
          purchaseOrderID
          rawMaterialID
          rawMaterialJSON
          productPrice
          discount
          taxID
          taxJSON
          taxValue
          discountValue
          quantity
          receivedQuantity
          paymentType
          total
          createdAt
          updatedAt
        }
        rawMaterialInventoryID
        unitsReceived
        usedUnits
        closedState
        costUnit
        expirationDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const rawMaterialInventoryBatchesByCompanyIDAndExpirationDate = /* GraphQL */ `
  query RawMaterialInventoryBatchesByCompanyIDAndExpirationDate(
    $companyID: ID!
    $expirationDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRawMaterialInventoryBatchesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rawMaterialInventoryBatchesByCompanyIDAndExpirationDate(
      companyID: $companyID
      expirationDate: $expirationDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        purchaseOrderRawMaterialID
        purchaseOrderRawMaterial {
          id
          companyID
          purchaseOrderID
          rawMaterialID
          rawMaterialJSON
          productPrice
          discount
          taxID
          taxJSON
          taxValue
          discountValue
          quantity
          receivedQuantity
          paymentType
          total
          createdAt
          updatedAt
        }
        rawMaterialInventoryID
        unitsReceived
        usedUnits
        closedState
        costUnit
        expirationDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const purchaseOrderRawMaterialsByRawMaterialIDAndCompanyID = /* GraphQL */ `
  query PurchaseOrderRawMaterialsByRawMaterialIDAndCompanyID(
    $rawMaterialID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderRawMaterialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrderRawMaterialsByRawMaterialIDAndCompanyID(
      rawMaterialID: $rawMaterialID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        purchaseOrderID
        purchaseOrder {
          id
          status
          countryID
          companyID
          addressDelivery
          dateDelivery
          realDateDelivery
          taxMode
          vendorID
          vendorJSON
          subTotalOne
          totalDiscount
          subTotalTwo
          totalTax
          totalPrice
          observations
          pdf
          createdAt
          updatedAt
        }
        rawMaterialID
        rawMaterial {
          id
          name
          barcode
          sku
          searchHelper
          isPerishable
          description
          units
          companyID
          countryID
          createdAt
          updatedAt
        }
        rawMaterialJSON
        rawMaterialInventoryBatches {
          nextToken
        }
        productPrice
        discount
        taxID
        taxJSON
        taxValue
        discountValue
        quantity
        receivedQuantity
        paymentType
        total
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const purchaseOrderRawMaterialsByPurchaseOrderIDAndCompanyID = /* GraphQL */ `
  query PurchaseOrderRawMaterialsByPurchaseOrderIDAndCompanyID(
    $purchaseOrderID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderRawMaterialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrderRawMaterialsByPurchaseOrderIDAndCompanyID(
      purchaseOrderID: $purchaseOrderID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        purchaseOrderID
        purchaseOrder {
          id
          status
          countryID
          companyID
          fileUrl
          addressDelivery
          dateDelivery
          realDateDelivery
          taxMode
          observations
          vendorID
          vendorJSON
          paymentType
          vendor {
            id
            name
            identificationNumber
            bankAccountNumber
            typeBankAccount
            bankName
            contactName
            contactEmail
            contactPhoneNumber
            vendorAddress
            vendorCountry
            vendorCity
            countryID
            companyID
            createdAt
            updatedAt
          }
          targetLocation {
            id
            name
            realName
            locationType
            country
            cityID
            address
            postalCode
            lon
            lat
            active
            inStore
            pickCollect
            deliveries
            img
            city {
              name
              timeZone
            }
            cashiers {
              items {
                id
                name
              }
            }
            companyID
            company {
              id
              companyName
              annualIncome
              numberEmployees
              businessType
              companyLogo
              companyWebpage
              superAdminID
              createdAt
              updatedAt
            }
            users {
              items {
                user {
                  id
                  familyName
                  name
                  email
                }
              }
            }
            countryID
            taxes {
              items {
                id
                taxID
                tax {
                  id
                  name
                  percentage
                }
              }
            }
            createdAt
            updatedAt
          }
          subTotalOne
          totalDiscount
          subTotalTwo
          totalTax
          totalPrice
          createdAt
          updatedAt
        }
        rawMaterialID
        rawMaterial {
          id
          name
          barcode
          sku
          searchHelper
          isPerishable
          description
          units
          companyID
          rawMaterialInventory {
            items {
              id
              stockLevel
              stockAlert
              rawMaterialID
              locationID
              location {
                id
                name
              }
            }
          }
          countryID
          createdAt
          updatedAt
        }
        rawMaterialJSON
        productPrice
        discount
        taxID
        taxJSON
        taxValue
        discountValue
        quantity
        receivedQuantity
        paymentType
        total
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const variantRawMaterialsByRawMaterialIDAndCompanyID = /* GraphQL */ `
  query VariantRawMaterialsByRawMaterialIDAndCompanyID(
    $rawMaterialID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVariantRawMaterialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    variantRawMaterialsByRawMaterialIDAndCompanyID(
      rawMaterialID: $rawMaterialID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        variantID
        variant {
          id
          name
          productName
          img
          barcode
          sku
          defaultPrice
          type
          searchHelper
          companyID
          productID
          countryID
          createdAt
          updatedAt
        }
        rawMaterialID
        rawMaterial {
          id
          name
          barcode
          sku
          searchHelper
          isPerishable
          description
          units
          companyID
          countryID
          createdAt
          updatedAt
        }
        rawMaterialQuantity
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const variantRawMaterialsByVariantIDAndCompanyID = /* GraphQL */ `
  query VariantRawMaterialsByVariantIDAndCompanyID(
    $variantID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVariantRawMaterialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    variantRawMaterialsByVariantIDAndCompanyID(
      variantID: $variantID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        variantID
        variant {
          id
          name
          productName
          img
          barcode
          sku
          defaultPrice
          type
          searchHelper
          companyID
          productID
          countryID
          createdAt
          updatedAt
        }
        rawMaterialID
        rawMaterial {
          id
          name
          barcode
          sku
          searchHelper
          isPerishable
          description
          units
          companyID
          countryID
          createdAt
          updatedAt
        }
        rawMaterialQuantity
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const invoicingCOSByCompanyID = /* GraphQL */ `
  query InvoicingCOSByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelInvoicingCOFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoicingCOSByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        razonSocial
        nit
        phoneNumber
        email
        address
        city
        resolutionKey
        resolutionName
        resolutionNumber
        testSetId
        prefix
        invoiceCurrentNumber
        creditNoteCurrentNumber
        debitNoteCurrentNumber
        rangeStart
        rangeEnd
        validFrom
        validUntil
        observations
        locationID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const productionOrdersByLocationIDAndCompanyID = /* GraphQL */ `
  query ProductionOrdersByLocationIDAndCompanyID(
    $locationID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductionOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productionOrdersByLocationIDAndCompanyID(
      locationID: $locationID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        countryID
        companyID
        dateDelivery
        observations
        realDateDelivery
        productionCost
        variants {
          nextToken
        }
        rawMaterials {
          nextToken
        }
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const productionOrdersByCompanyIDAndId = /* GraphQL */ `
  query ProductionOrdersByCompanyIDAndId(
    $companyID: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductionOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productionOrdersByCompanyIDAndId(
      companyID: $companyID
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        countryID
        companyID
        dateDelivery
        realDateDelivery
        productionCost
        locationID
        location {
          id
          name
        }
        variants {
          items {
            id
          }
          nextToken
        }
        rawMaterials {
          items {
            id
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getProductionOrder = /* GraphQL */ `
  query GetProductionOrder($id: ID!) {
    getProductionOrder(id: $id) {
      id
      status
      countryID
      companyID
      dateDelivery
      observations
      locationID
      location {
        id
        name
      }
      realDateDelivery
      productionCost
      variants {
        items {
          id
          companyID
          productionOrderID
          variantID
          variantJSON
          quantity
          createdAt
          updatedAt
        }
        nextToken
      }
      rawMaterials {
        items {
          id
          companyID
          productionOrderID
          rawMaterialID
          rawMaterialJSON
          quantity
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const productionOrderVariantsByVariantIDAndCompanyID = /* GraphQL */ `
  query ProductionOrderVariantsByVariantIDAndCompanyID(
    $variantID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductionOrderVariantsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productionOrderVariantsByVariantIDAndCompanyID(
      variantID: $variantID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        productionOrderID
        productionOrder {
          id
          status
          countryID
          companyID
          dateDelivery
          observations
          realDateDelivery
          productionCost
          locationID
          createdAt
          updatedAt
        }
        variantID
        variant {
          id
          name
          productName
          img
          barcode
          sku
          defaultPrice
          type
          searchHelper
          companyID
          productID
          countryID
          createdAt
          updatedAt
        }
        variantJSON
        inventoryBatches {
          nextToken
        }
        quantity
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const productionOrderVariantsByProductionOrderIDAndCompanyID = /* GraphQL */ `
  query ProductionOrderVariantsByProductionOrderIDAndCompanyID(
    $productionOrderID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductionOrderVariantsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productionOrderVariantsByProductionOrderIDAndCompanyID(
      productionOrderID: $productionOrderID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        productionOrderID
        productionOrder {
          id
          status
          countryID
          companyID
          dateDelivery
          realDateDelivery
          productionCost
          createdAt
          updatedAt
        }
        variantID
        variant {
          id
          name
          productName
          img
          barcode
          sku
          defaultPrice
          type
          searchHelper
          companyID
          productID
          countryID
          inventory {
            items {
              id
              price
              stockLevel
              stockAlert
              variantID
              locationID
              location {
                id
                name
              }
            }
          }
          product {
            name
            isPerishable
          }
          createdAt
          updatedAt
        }
        variantJSON
        quantity
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const productionOrderRawMaterialsByRawMaterialIDAndCompanyID = /* GraphQL */ `
  query ProductionOrderRawMaterialsByRawMaterialIDAndCompanyID(
    $rawMaterialID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductionOrderRawMaterialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productionOrderRawMaterialsByRawMaterialIDAndCompanyID(
      rawMaterialID: $rawMaterialID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        productionOrderID
        productionOrder {
          id
          status
          countryID
          companyID
          dateDelivery
          observations
          realDateDelivery
          productionCost
          locationID
          createdAt
          updatedAt
        }
        rawMaterialID
        rawMaterial {
          id
          name
          barcode
          sku
          searchHelper
          isPerishable
          description
          units
          companyID
          countryID
          createdAt
          updatedAt
        }
        rawMaterialJSON
        quantity
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const productionOrderRawMaterialsByProductionOrderIDAndCompanyID = /* GraphQL */ `
  query ProductionOrderRawMaterialsByProductionOrderIDAndCompanyID(
    $productionOrderID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductionOrderRawMaterialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productionOrderRawMaterialsByProductionOrderIDAndCompanyID(
      productionOrderID: $productionOrderID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        productionOrderID
        productionOrder {
          id
          status
          countryID
          companyID
          dateDelivery
          realDateDelivery
          productionCost
          createdAt
          updatedAt
        }
        rawMaterialID
        rawMaterial {
          id
          name
          barcode
          sku
          searchHelper
          isPerishable
          description
          units
          companyID
          countryID
          createdAt
          updatedAt
        }
        rawMaterialJSON
        quantity
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listInvoicingMXES = /* GraphQL */ `
  query ListInvoicingMXES(
    $filter: ModelInvoicingMXFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoicingMXES(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyID
        rfcEmisor
        base64Cer
        base64Key
        password
        regimenFiscal
        domicilioFiscal
        numberCer
        folio
        numberFolio
        ConsecutiveFolio
        addressCompany
        nameCompany
        emailCompany
        usoCFDI
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const variantsByCountryIDAndSearchHelper = /* GraphQL */ `
  query VariantsByCountryIDAndSearchHelper(
    $countryID: ID!
    $searchHelper: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    variantsByCountryIDAndSearchHelper(
      countryID: $countryID
      searchHelper: $searchHelper
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        productName
        img
        barcode
        sku
        defaultPrice
        type
        companyID
        rawMaterials {
          items {
            id
            companyID
            variantID
            rawMaterialID
            rawMaterial {
              id
              name
              barcode
              sku
              searchHelper
              isPerishable
              description
              units
              companyID
              countryID
              rawMaterialInventory {
                items {
                  id
                  stockLevel
                  stockAlert
                  companyID
                  rawMaterialID
                  locationID
                  location {
                    id
                    name
                  }
                  countryID
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              updatedAt
            }
            rawMaterialQuantity
            createdAt
            updatedAt
          }
          nextToken
        }
        productID
        product {
          id
          type
          name
          categoryID
          category {
            name
          }
          img
          units
          description
          companyID
          isPerishable
          company {
            id
            companyName
            annualIncome
            numberEmployees
            businessType
            superAdminID
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        inventory {
          items {
            id
            price
            currency
            stockLevel
            companyID
            variantID
            locationID
            createdAt
            updatedAt
          }
          nextToken
        }
        users {
          items {
            id
            companyID
            variantID
            userID
            countryID
            createdAt
            updatedAt
          }
          nextToken
        }
        taxes {
          items {
            tax {
              id
              name
              percentage
            }
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const orderPaymentMethodsByOrderID = /* GraphQL */ `
  query OrderPaymentMethodsByOrderID(
    $orderID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrderPaymentMethodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderPaymentMethodsByOrderID(
      orderID: $orderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        value
        orderID
        paymentMethodID
        moreInfoJSON
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const recommendationLocationsByRecommendationIDAndCompanyID = /* GraphQL */ `
  query RecommendationLocationsByRecommendationIDAndCompanyID(
    $recommendationID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRecommendationLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    recommendationLocationsByRecommendationIDAndCompanyID(
      recommendationID: $recommendationID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        recommendationID
        recommendation {
          id
          productID
          companyID
          countryID
          createdAt
          updatedAt
        }
        companyID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const recommendationLocationsByLocationIDAndCompanyID = /* GraphQL */ `
  query RecommendationLocationsByLocationIDAndCompanyID(
    $locationID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRecommendationLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    recommendationLocationsByLocationIDAndCompanyID(
      locationID: $locationID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        recommendationID
        recommendation {
          id
          productID
          product {
            id
            type
            name
            categoryID
            category {
              id
              name
            }
            img
            color
            units
            description
            companyID
            isPerishable
            company {
              id
              companyName
              annualIncome
              numberEmployees
              businessType
              companyLogo
              companyWebpage
              superAdminID
              createdAt
              updatedAt
            }
            variants {
              items {
                id
                name
                productName
                img
                sku
                barcode
                rawMaterials {
                  items {
                    rawMaterialID
                    rawMaterialQuantity
                    rawMaterial {
                      id
                      name
                      barcode
                      sku
                      searchHelper
                      isPerishable
                      description
                      units
                      companyID
                      countryID
                      rawMaterialInventory {
                        items {
                          id
                          stockLevel
                          stockAlert
                          companyID
                          rawMaterialID
                          locationID
                          location {
                            id
                            name
                          }
                          countryID
                          createdAt
                          updatedAt
                        }
                        nextToken
                      }
                      createdAt
                      updatedAt
                    }
                  }
                }
                type
                taxes {
                  items {
                    tax {
                      id
                      name
                      percentage
                    }
                  }
                }
                users {
                  items {
                    id
                    commission
                    commissionType
                    enabled
                    variantID
                    user {
                      id
                      name
                      familyName
                      locations {
                        items {
                          id
                          companyID
                          locationID
                          userID
                        }
                      }
                    }
                  }
                }
              }
            }
            attributes {
              items {
                id
                name
                options
                order
              }
            }
            vendorProducts {
              items {
                vendorID
              }
            }

            countryID
          }
          companyID
          countryID
          createdAt
          updatedAt
        }
        companyID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const invoicingElectronicMXESByIdOrder = /* GraphQL */ `
  query InvoicingElectronicMXESByIdOrder(
    $IdOrder: String!
    $sortDirection: ModelSortDirection
    $filter: ModelinvoicingElectronicMXFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoicingElectronicMXESByIdOrder(
      IdOrder: $IdOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        data
        pdf
        status
        XML
        email
        CadenaOriginalTimbre
        UUID
        CodigoQr
        IdOrder
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInvoicingCO = /* GraphQL */ `
  query GetInvoicingCO($id: ID!) {
    getInvoicingCO(id: $id) {
      id
      companyID
      razonSocial
      nit
      phoneNumber
      address
      city
      resolutionKey
      resolutionNumber
      resolutionName
      testSetId
      prefix
      invoiceCurrentNumber
      rangeStart
      rangeEnd
      validFrom
      validUntil
      observations
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const invoicingElectronicCOSByOrderID = /* GraphQL */ `
  query InvoicingElectronicCOSByOrderID(
    $orderID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelinvoicingElectronicCOFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoicingElectronicCOSByOrderID(
      orderID: $orderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        data
        pdf
        xml
        numberInvoicing
        cufe
        dianStatus
        dianReason
        dianStateReason
        dianURL
        status
        orderID
        orderJSON
        createdAt
        updatedAt
        type
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuotation = /* GraphQL */ `
  query GetQuotation($id: ID!) {
    getQuotation(id: $id) {
      id
      expirationDate
      variantJSON
      variants {
        nextToken
        __typename
      }
      rawMaterials
      companyID
      consecutive
      subTotalOne
      totalDiscount
      subTotalTwo
      totalTax
      totalPrice
      state
      userID
      observations
      createdByUser {
        id
        name
        familyName
        email
        phoneNumber
        role
        status
        color
        isConnected
        connectedStore
        companyID
        countryID
        createdAt
        updatedAt
        __typename
      }
      countryID
      description
      useImages
      createdAt
      custumerID
      customer {
        id
        companyID
        type
        name
        email
        phoneNumber
        governmentID
        countryID
        invoicing
        createdAt
        updatedAt
        __typename
      }
      customerJSON
      updatedAt
      __typename
    }
  }
`;
export const quotationsByCompanyIDAndCreatedAt = /* GraphQL */ `
  query QuotationsByCompanyIDAndCreatedAt(
    $companyID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuotationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quotationsByCompanyIDAndCreatedAt(
      companyID: $companyID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        expirationDate
        variantJSON
        rawMaterials
        companyID
        consecutive
        subTotalOne
        totalDiscount
        subTotalTwo
        totalTax
        totalPrice
        state
        userID
        countryID
        description
        observations
        useImages
        createdAt
        custumerID
        customerJSON
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const inventoryBatchesByVariantIDAndExpirationDate = /* GraphQL */ `
  query InventoryBatchesByVariantIDAndExpirationDate(
    $variantID: ID!
    $expirationDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryBatchesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryBatchesByVariantIDAndExpirationDate(
      variantID: $variantID
      expirationDate: $expirationDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        purchaseOrderProductsID
        productionOrderVariantsID
        inventoryID
        locationID
        variantID
        unitsReceived
        usedUnits
        closedState
        costUnit
        expirationDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const inventoryBatchesByLocationIDAndExpirationDate = /* GraphQL */ `
  query InventoryBatchesByLocationIDAndExpirationDate(
    $locationID: ID!
    $expirationDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryBatchesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryBatchesByLocationIDAndExpirationDate(
      locationID: $locationID
      expirationDate: $expirationDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        purchaseOrderProductsID
        productionOrderVariantsID
        inventoryID
        locationID
        variantID
        unitsReceived
        usedUnits
        closedState
        costUnit
        expirationDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const quotationVariantsByVariantIDAndCompanyID = /* GraphQL */ `
  query QuotationVariantsByVariantIDAndCompanyID(
    $variantID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuotationVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quotationVariantsByVariantIDAndCompanyID(
      variantID: $variantID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        quotationID
        quotation {
          id
          expirationDate
          variantJSON
          rawMaterials
          companyID
          consecutive
          subTotalOne
          totalDiscount
          subTotalTwo
          totalTax
          totalPrice
          state
          userID
          countryID
          description
          observations
          useImages
          createdAt
          custumerID
          customerJSON
          taxMode
          orderID
          updatedAt
        }
        variantID
        variant {
          id
          name
          productName
          img
          barcode
          sku
          defaultPrice
          inventory {
            items {
              id
              price
              stockLevel
              stockAlert
              variantID
              locationID
              location {
                id
                name
              }
            }
          }
          type
          searchHelper
          companyID
          productID
          countryID
          createdAt
          updatedAt
        }
        variantJSON
        salePrice
        discount
        taxValue
        finalPrice
        taxes
        quantity
        isFast
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const quotationVariantsByCompanyID = /* GraphQL */ `
  query QuotationVariantsByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelQuotationVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quotationVariantsByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        quotationID
        variantID
        variant {
          name
          productName
          productID
          type
          barcode
          sku
        }
        salePrice
        discount
        taxValue
        finalPrice
        taxes
        quantity
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const quotationVariantsByQuotationIDAndCompanyID = /* GraphQL */ `
  query QuotationVariantsByQuotationIDAndCompanyID(
    $quotationID: ID!
    $companyID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuotationVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quotationVariantsByQuotationIDAndCompanyID(
      quotationID: $quotationID
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        quotationID
        variantID
        salePrice
        discount
        discountValue
        taxValue
        finalPrice
        taxes
        quantity
        isFast
        createdAt
        updatedAt
        variantID
        variantJSON
        variant {
          id
          name
          productName
          productID
          type
          barcode
          sku
          img
          rawMaterials {
            items {
              rawMaterialID
              rawMaterialQuantity
              rawMaterial {
                id
                name
                barcode
                sku
                searchHelper
                isPerishable
                description
                units
                companyID
                countryID
                rawMaterialInventory {
                  items {
                    id
                    stockLevel
                    stockAlert
                    companyID
                    rawMaterialID
                    locationID
                    countryID
                  }
                }
                createdAt
                updatedAt
              }
            }
          }
          countryID
          taxes {
            items {
              tax {
                id
                name
                percentage
              }
            }
          }
          inventory {
            items {
              id
              price
              stockLevel
              stockAlert
              variantID
              locationID
              location {
                id
                name
              }
            }
          }
          product {
            id
            name
            isPerishable
            units
            description
          }
          createdAt
          updatedAt
        }
      }
      nextToken
      __typename
    }
  }
`;
export const getListCustomer = /* GraphQL */ `
  query GetListCustomer($id: ID!) {
    getListCustomer(id: $id) {
      id
      countryID
      companyID
      name
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listActivities = /* GraphQL */ `
  query ListActivities(
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyID
        title
        formActivities
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const activitiesByCompanyID = /* GraphQL */ `
  query ActivitiesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activitiesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        title
        formActivities
        isActive
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getActivity = /* GraphQL */ `
  query GetActivity($id: ID!) {
    getActivity(id: $id) {
      id
      companyID
      title
      formActivities
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const promotionsByCompanyID = /* GraphQL */ `
  query PromotionsByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPromotionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    promotionsByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        countryID
        type
        name
        dateInit
        dateEnd
        fixedAmount
        priceCombo
        percentageAmount
        amountMinPurchase
        applyListProduct
        applyAmountMinAllPurchase
        applyAmountMinProducts
        applySpecificProducts
        applyamountMin
        applyLimit
        applySpecificLocation
        applySpecificDaysTimes
        applycumulative
        applyListCustomer
        applyAnonymousSales
        finishAccordingBudget
        finishAccordingBudgetValue
        applyMaxAmountForSale
        applyMaxAmountForSaleValue
        applyMaxAmountForCustomer
        applyMaxAmountForCustomerValue
        applyTransactionsMaxForCustomer
        applyTransactionsMaxForCustomerValue
        isTimeUnlimited
        discountCode
        state
        taxes
        createdAt
        updatedAt
        promotionPriceLevel {
          items {
            id
            countryID
            companyID
            count
            typeDiscount
            price
            promotionID
            variantID
            createdAt
            updatedAt
          }
          nextToken
        }
        promotionDayTime {
          items {
            id
            countryID
            companyID
            promotionID
            day
            dateInit
            dateEnd
            createdAt
            updatedAt
            __typename
          }
        }
        promotionProduct {
          items {
            id
            countryID
            companyID
            promotionID
            productID
            count
            product {
              id
              type
              name
              categoryID
              category {
                name
              }
              variants {
                items {
                  id
                  name
                  productName
                  img
                  barcode
                  sku
                  defaultPrice
                  type
                  taxes {
                    items {
                      tax {
                        id
                        name
                        percentage
                      }
                    }
                  }
                  rawMaterials {
                    items {
                      id
                      companyID
                      variantID
                      rawMaterialID
                      rawMaterial {
                        id
                        name
                        barcode
                        sku
                        searchHelper
                        isPerishable
                        description
                        units
                        companyID
                        countryID
                        rawMaterialInventory {
                          items {
                            id
                            stockLevel
                            stockAlert
                            companyID
                            rawMaterialID
                            locationID
                            countryID
                          }
                        }
                        createdAt
                        updatedAt
                      }
                      rawMaterialQuantity
                      createdAt
                      updatedAt
                    }
                    nextToken
                  }
                  inventory {
                    items {
                      id
                      price
                      stockLevel
                      stockAlert
                      variantID
                      locationID
                      location {
                        id
                        name
                      }
                    }
                  }
                }
              }
              attributes {
                items {
                  id
                  name
                  options
                  order
                }
              }
              img
              color
              units
              description
              companyID
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
            __typename
          }
        }
        promotionLocation {
          items {
            id
            countryID
            companyID
            promotionID
            locationID
            createdAt
            updatedAt
            __typename
          }
        }
        promotionVariant {
          items {
            id
            countryID
            companyID
            promotionID
            variantID
            variant {
              id
              name
              productName
              img
              barcode
              sku
              rawMaterials {
                items {
                  id
                  companyID
                  variantID
                  rawMaterialID
                  rawMaterialQuantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              inventory {
                items {
                  id
                  price
                  stockLevel
                  stockAlert
                  variantID
                  locationID
                  location {
                    id
                    name
                  }
                }
              }
              defaultPrice
              type
              companyID
              productID
              countryID
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
            __typename
          }
        }

        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getPromotion = /* GraphQL */ `
  query GetPromotion($id: ID!) {
    getPromotion(id: $id) {
      id
      companyID
      countryID
      type
      name
      dateInit
      dateEnd
      fixedAmount
      priceCombo
      percentageAmount
      amountMinPurchase
      applyListProduct
      applyAmountMinAllPurchase
      applyAmountMinProducts
      applySpecificProducts
      applyamountMin
      applyLimit
      applySpecificLocation
      applySpecificDaysTimes
      applycumulative
      applyListCustomer
      applyAnonymousSales
      promotionLocation {
        items {
          id
          countryID
          companyID
          promotionID
          locationID
          createdAt
          updatedAt
          __typename
        }
      }
      promotionPriceLevel {
        items {
          id
          countryID
          companyID
          count
          typeDiscount
          price
          promotionID
          variantID
          createdAt
          updatedAt
        }
        nextToken
      }
      promotionProduct {
        items {
          id
          countryID
          companyID
          promotionID
          productID
          count
          product {
            id
            type
            name
            categoryID
            category {
              name
            }
            variants {
              items {
                id
                name
                productName
                img
                barcode
                sku
                defaultPrice
                type
              }
            }
            img
            units
            description
            companyID
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          __typename
        }
      }
      promotionVariant {
        items {
          id
          countryID
          companyID
          promotionID
          variantID
          variant {
            id
            name
            productName
            img
            barcode
            sku
            defaultPrice
            type
            rawMaterials {
              items {
                id
                companyID
                variantID
                rawMaterialID
                rawMaterialQuantity
                createdAt
                updatedAt
              }
              nextToken
            }
            inventory {
              items {
                id
                price
                stockLevel
                stockAlert
                variantID
                locationID
                location {
                  id
                  name
                }
              }
            }
            companyID
            productID
            countryID
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          __typename
        }
      }
      promotionDayTime {
        items {
          id
          countryID
          companyID
          promotionID
          day
          dateInit
          dateEnd
          createdAt
          updatedAt
          __typename
        }
      }
      promotionListCustomer {
        nextToken
        __typename
      }
      finishAccordingBudget
      finishAccordingBudgetValue
      applyMaxAmountForSale
      applyMaxAmountForSaleValue
      applyMaxAmountForCustomer
      applyMaxAmountForCustomerValue
      applyTransactionsMaxForCustomer
      applyTransactionsMaxForCustomerValue
      isTimeUnlimited
      discountCode
      state
      taxes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPromotions = /* GraphQL */ `
  query ListPromotions(
    $filter: ModelPromotionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPromotions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyID
        countryID
        type
        name
        dateInit
        dateEnd
        fixedAmount
        priceCombo
        percentageAmount
        amountMinPurchase
        applyListProduct
        applyAmountMinAllPurchase
        applyAmountMinProducts
        applySpecificProducts
        applyamountMin
        applyLimit
        applySpecificLocation
        applySpecificDaysTimes
        applycumulative
        applyListCustomer
        applyAnonymousSales
        apllyPrintDiscountCodePos
        applylimitPromotion
        promotionPriceLevel {
          items {
            id
            countryID
            companyID
            count
            typeDiscount
            price
            promotionID
            variantID
            createdAt
            updatedAt
          }
          nextToken
        }
        promotionVariant {
          items {
            id
            countryID
            companyID
            promotionID
            variantID
            createdAt
            updatedAt
          }
          nextToken
        }
        promotionLocation {
          nextToken
        }
        promotionDayTime {
          nextToken
        }
        promotionListCustomer {
          nextToken
        }
        promotionProduct {
          nextToken
        }
        orderVariant {
          nextToken
        }
        finishAccordingBudget
        finishAccordingBudgetValue
        applyMaxAmountForSale
        applyMaxAmountForSaleValue
        applyMaxAmountForCustomer
        applyMaxAmountForCustomerValue
        applyTransactionsMaxForCustomer
        applyTransactionsMaxForCustomerValue
        apllyPrintDiscountCodePosValue
        applyLimitPromotionValue
        isTimeUnlimited
        discountCode
        state
        taxes
        img
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const promotionsByStateAndIsTimeUnlimited = /* GraphQL */ `
  query PromotionsByStateAndIsTimeUnlimited(
    $state: Float!
    $isTimeUnlimited: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPromotionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    promotionsByStateAndIsTimeUnlimited(
      state: $state
      isTimeUnlimited: $isTimeUnlimited
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        countryID
        type
        name
        dateInit
        dateEnd
        fixedAmount
        priceCombo
        percentageAmount
        amountMinPurchase
        applyListProduct
        applyAmountMinAllPurchase
        applyAmountMinProducts
        applySpecificProducts
        applyamountMin
        applyLimit
        applySpecificLocation
        applySpecificDaysTimes
        applycumulative
        applyListCustomer
        applyAnonymousSales
        finishAccordingBudget
        finishAccordingBudgetValue
        applyMaxAmountForSale
        applyMaxAmountForSaleValue
        applyMaxAmountForCustomer
        applyMaxAmountForCustomerValue
        applyTransactionsMaxForCustomer
        applyTransactionsMaxForCustomerValue
        isTimeUnlimited
        discountCode
        state
        taxes
        createdAt
        updatedAt
        promotionPriceLevel {
          items {
            id
            countryID
            companyID
            count
            typeDiscount
            price
            promotionID
            variantID
            createdAt
            updatedAt
          }
          nextToken
        }
        promotionDayTime {
          items {
            id
            countryID
            companyID
            promotionID
            day
            dateInit
            dateEnd
            createdAt
            updatedAt
            __typename
          }
        }
        promotionProduct {
          items {
            id
            countryID
            companyID
            promotionID
            productID
            count
            product {
              id
              type
              name
              categoryID
              category {
                name
              }
              variants {
                items {
                  id
                  name
                  productName
                  img
                  barcode
                  sku
                  defaultPrice
                  type
                  taxes {
                    items {
                      tax {
                        id
                        name
                        percentage
                      }
                    }
                  }
                  rawMaterials {
                    items {
                      id
                      companyID
                      variantID
                      rawMaterialID
                      rawMaterial {
                        id
                        name
                        barcode
                        sku
                        searchHelper
                        isPerishable
                        description
                        units
                        companyID
                        countryID
                        rawMaterialInventory {
                          items {
                            id
                            stockLevel
                            stockAlert
                            companyID
                            rawMaterialID
                            locationID
                            countryID
                          }
                        }
                        createdAt
                        updatedAt
                      }
                      rawMaterialQuantity
                      createdAt
                      updatedAt
                    }
                    nextToken
                  }
                  inventory {
                    items {
                      id
                      price
                      stockLevel
                      stockAlert
                      variantID
                      locationID
                      location {
                        id
                        name
                      }
                    }
                  }
                }
              }
              attributes {
                items {
                  id
                  name
                  options
                  order
                }
              }
              img
              color
              units
              description
              companyID
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
            __typename
          }
        }
        promotionLocation {
          items {
            id
            countryID
            companyID
            promotionID
            locationID
            createdAt
            updatedAt
            __typename
          }
        }
        promotionVariant {
          items {
            id
            countryID
            companyID
            promotionID
            variantID
            variant {
              id
              name
              productName
              img
              barcode
              sku
              rawMaterials {
                items {
                  id
                  companyID
                  variantID
                  rawMaterialID
                  rawMaterialQuantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              inventory {
                items {
                  id
                  price
                  stockLevel
                  stockAlert
                  variantID
                  locationID
                  location {
                    id
                    name
                  }
                }
              }
              defaultPrice
              type
              companyID
              productID
              countryID
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
            __typename
          }
        }

        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const locationsByCompanyIDAndLocationType = /* GraphQL */ `
  query LocationsByCompanyIDAndLocationType(
    $companyID: ID!
    $locationType: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationsByCompanyIDAndLocationType(
      companyID: $companyID
      locationType: $locationType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        realName
        locationType
        country
        cityID
        address
        postalCode
        lon
        lat
        active
        inStore
        pickCollect
        deliveries
        img
        companyID
        countryID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const searchJournals = /* GraphQL */ `
  query SearchJournals(
    $filter: SearchableJournalFilterInput
    $sort: [SearchableJournalSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableJournalAggregationInput]
  ) {
    searchJournals(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        companyID
        recordValue
        currency
        recordType
        locationID
        location {
          id
          name
          locationType
          country
          cityID
          address
          postalCode
          lon
          lat
          active
          inStore
          pickCollect
          deliveries
          img
          companyID
          countryID
          createdAt
          updatedAt
        }
        locationJSON
        cashierID
        cashierJSON
        userID
        userJSON
        paymentMethodID
        description
        variantID
        variantJSON
        createdAtLocal
        activityID
        activityForm
        countryID
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;

export const searchProducts = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: [SearchableProductSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProductAggregationInput]
  ) {
    searchProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        type
        name
        realName
        categoryID
        category {
          id
          name
        }
        img
        color
        units
        description
        companyID
        isPerishable
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          superAdminID
          createdAt
          updatedAt
        }
        variants {
          items {
            id
            name
            productName
            img
            sku
            defaultPrice
            barcode
            promotion {
              items {
                promotionID
                promotion {
                  id
                  type
                  dateInit
                  dateEnd
                  fixedAmount
                  percentageAmount
                  amountMinPurchase
                  applyListProduct
                  applyAmountMinAllPurchase
                  applyAmountMinProducts
                  applySpecificProducts
                  applyamountMin
                  applyLimit
                  applySpecificLocation
                  applySpecificDaysTimes
                  applycumulative
                  applyListCustomer
                  applyAnonymousSales
                  finishAccordingBudget
                  finishAccordingBudgetValue
                  applyMaxAmountForSale
                  applyMaxAmountForSaleValue
                  applyMaxAmountForCustomer
                  applyMaxAmountForCustomerValue
                  applyTransactionsMaxForCustomer
                  applyTransactionsMaxForCustomerValue
                }
              }
            }
            rawMaterials {
              items {
                rawMaterialID
                rawMaterialQuantity
                rawMaterial {
                  id
                  name
                  barcode
                  sku
                  searchHelper
                  isPerishable
                  description
                  units
                  companyID
                  countryID
                  rawMaterialInventory {
                    items {
                      id
                      stockLevel
                      stockAlert
                      companyID
                      rawMaterialID
                      locationID
                      countryID
                    }
                  }
                  createdAt
                  updatedAt
                }
              }
            }
            type
            taxes {
              items {
                tax {
                  id
                  name
                  percentage
                }
              }
            }
            users {
              items {
                id
                commission
                commissionType
                enabled
                variantID
                user {
                  id
                  name
                  familyName
                  locations {
                    items {
                      id
                      companyID
                      locationID
                      userID
                    }
                  }
                }
              }
            }
          }
        }
        attributes {
          items {
            id
            name
            options
            order
          }
        }
        vendorProducts {
          items {
            vendorID
          }
        }

        countryID
        createdAt
        updatedAt
      }
      nextToken

      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const listListCustomers = /* GraphQL */ `
  query ListListCustomers(
    $filter: ModelListCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listListCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        countryID
        companyID
        name
        color
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listFidelityPrograms = /* GraphQL */ `
  query ListFidelityPrograms(
    $filter: ModelFidelityProgramFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFidelityPrograms(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        programName
        monetaryValuePoints
        monetaryValueCurrency
        isExpirationEnabled
        expirationDays
        pointsLimitEnabled
        maxPoints
        minPoints
        activitiesChecked
        statusProgram
        companyID
        products {
          nextToken
        }
        categories {
          nextToken
        }
        fidelityLevels {
          nextToken
        }
        redemptionOptions
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFidelityProgramProduct = /* GraphQL */ `
  query GetFidelityProgramProduct($id: ID!) {
    getFidelityProgramProduct(id: $id) {
      id
      fidelityProgramID
      fidelityProgram {
        id
        programName
        monetaryValuePoints
        monetaryValueCurrency
        isExpirationEnabled
        expirationDays
        pointsLimitEnabled
        maxPoints
        minPoints
        activitiesChecked
        companyID
        products {
          nextToken
        }
        categories {
          nextToken
        }
        fidelityLevels {
          nextToken
        }
        redemptionOptions
        createdAt
        updatedAt
      }
      productID
      product {
        id
        type
        name
        realName
        categoryID
        category {
          id
          name
          type
          companyID
          countryID
          createdAt
          updatedAt
        }
        img
        color
        units
        minDuration
        customOneName
        customOneValue
        customTwoName
        customTwoValue
        customThreeName
        customThreeValue
        description
        isPerishable
        promotion {
          nextToken
        }
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          phoneNumber
          mainEmail
          mainName
          superAdminID
          mainCountryID
          isNew
          saleObjective
          crmID
          ipAddress
          userAgent
          createdAt
          updatedAt
        }
        variants {
          nextToken
        }
        customProperty {
          nextToken
        }
        fidelityProgram {
          nextToken
        }
        attributes {
          nextToken
        }
        countryID
        vendorProducts {
          nextToken
        }
        purchaseOrderProducts {
          nextToken
        }
        createdAt
        updatedAt
      }
      companyID
      multiplier
      createdAt
      updatedAt
    }
  }
`;
export const listFidelityProgramProducts = /* GraphQL */ `
  query ListFidelityProgramProducts(
    $filter: ModelFidelityProgramProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFidelityProgramProducts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fidelityProgramID
        fidelityProgram {
          id
          programName
          monetaryValuePoints
          monetaryValueCurrency
          isExpirationEnabled
          expirationDays
          pointsLimitEnabled
          maxPoints
          minPoints
          activitiesChecked
          companyID
          redemptionOptions
          createdAt
          updatedAt
        }
        productID
        product {
          id
          type
          name
          realName
          categoryID
          img
          color
          units
          minDuration
          customOneName
          customOneValue
          customTwoName
          customTwoValue
          customThreeName
          customThreeValue
          description
          isPerishable
          companyID
          countryID
          createdAt
          updatedAt
        }
        companyID
        multiplier
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const fidelityProgramProductsByFidelityProgramIDAndProductID = /* GraphQL */ `
  query FidelityProgramProductsByFidelityProgramIDAndProductID(
    $fidelityProgramID: ID!
    $productID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFidelityProgramProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    fidelityProgramProductsByFidelityProgramIDAndProductID(
      fidelityProgramID: $fidelityProgramID
      productID: $productID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fidelityProgramID
        fidelityProgram {
          id
          programName
          monetaryValuePoints
          monetaryValueCurrency
          isExpirationEnabled
          expirationDays
          pointsLimitEnabled
          maxPoints
          minPoints
          activitiesChecked
          companyID
          redemptionOptions
          createdAt
          updatedAt
        }
        productID
        product {
          id
          type
          name
          realName
          categoryID
          img
          color
          units
          minDuration
          customOneName
          customOneValue
          customTwoName
          customTwoValue
          customThreeName
          customThreeValue
          description
          isPerishable
          companyID
          countryID
          createdAt
          updatedAt
        }
        companyID
        multiplier
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const fidelityProgramProductsByProductIDAndFidelityProgramID = /* GraphQL */ `
  query FidelityProgramProductsByProductIDAndFidelityProgramID(
    $productID: ID!
    $fidelityProgramID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFidelityProgramProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    fidelityProgramProductsByProductIDAndFidelityProgramID(
      productID: $productID
      fidelityProgramID: $fidelityProgramID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fidelityProgramID
        fidelityProgram {
          id
          programName
          monetaryValuePoints
          monetaryValueCurrency
          isExpirationEnabled
          expirationDays
          pointsLimitEnabled
          maxPoints
          minPoints
          activitiesChecked
          companyID
          redemptionOptions
          createdAt
          updatedAt
        }
        productID
        product {
          id
          type
          name
          realName
          categoryID
          img
          color
          units
          minDuration
          customOneName
          customOneValue
          customTwoName
          customTwoValue
          customThreeName
          customThreeValue
          description
          isPerishable
          companyID
          countryID
          createdAt
          updatedAt
        }
        companyID
        multiplier
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const fidelityProgramProductsByCompanyIDAndFidelityProgramID = /* GraphQL */ `
  query FidelityProgramProductsByCompanyIDAndFidelityProgramID(
    $companyID: ID!
    $fidelityProgramID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFidelityProgramProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    fidelityProgramProductsByCompanyIDAndFidelityProgramID(
      companyID: $companyID
      fidelityProgramID: $fidelityProgramID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fidelityProgramID
        fidelityProgram {
          id
          programName
          monetaryValuePoints
          monetaryValueCurrency
          isExpirationEnabled
          expirationDays
          pointsLimitEnabled
          maxPoints
          minPoints
          activitiesChecked
          companyID
          redemptionOptions
          createdAt
          updatedAt
        }
        productID
        product {
          id
          type
          name
          realName
          categoryID
          img
          color
          units
          minDuration
          customOneName
          customOneValue
          customTwoName
          customTwoValue
          customThreeName
          customThreeValue
          description
          isPerishable
          companyID
          countryID
          createdAt
          updatedAt
        }
        companyID
        multiplier
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFidelityProgramCategory = /* GraphQL */ `
  query GetFidelityProgramCategory($id: ID!) {
    getFidelityProgramCategory(id: $id) {
      id
      fidelityProgramID
      fidelityProgram {
        id
        programName
        monetaryValuePoints
        monetaryValueCurrency
        isExpirationEnabled
        expirationDays
        pointsLimitEnabled
        maxPoints
        minPoints
        activitiesChecked
        companyID
        products {
          nextToken
        }
        categories {
          nextToken
        }
        fidelityLevels {
          nextToken
        }
        redemptionOptions
        createdAt
        updatedAt
      }
      categoryID
      category {
        id
        name
        type
        companyID
        company {
          id
          companyName
          annualIncome
          numberEmployees
          businessType
          companyLogo
          companyWebpage
          phoneNumber
          mainEmail
          mainName
          superAdminID
          mainCountryID
          isNew
          saleObjective
          crmID
          ipAddress
          userAgent
          createdAt
          updatedAt
        }
        fidelityProgram {
          nextToken
        }
        countryID
        createdAt
        updatedAt
      }
      companyID
      multiplier
      createdAt
      updatedAt
    }
  }
`;
export const listFidelityProgramCategories = /* GraphQL */ `
  query ListFidelityProgramCategories(
    $filter: ModelFidelityProgramCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFidelityProgramCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fidelityProgramID
        fidelityProgram {
          id
          programName
          monetaryValuePoints
          monetaryValueCurrency
          isExpirationEnabled
          expirationDays
          pointsLimitEnabled
          maxPoints
          minPoints
          activitiesChecked
          companyID
          redemptionOptions
          createdAt
          updatedAt
        }
        categoryID
        category {
          id
          name
          type
          companyID
          countryID
          createdAt
          updatedAt
        }
        companyID
        multiplier
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const fidelityProgramCategoriesByFidelityProgramIDAndCategoryID = /* GraphQL */ `
  query FidelityProgramCategoriesByFidelityProgramIDAndCategoryID(
    $fidelityProgramID: ID!
    $categoryID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFidelityProgramCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    fidelityProgramCategoriesByFidelityProgramIDAndCategoryID(
      fidelityProgramID: $fidelityProgramID
      categoryID: $categoryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fidelityProgramID
        fidelityProgram {
          id
          programName
          monetaryValuePoints
          monetaryValueCurrency
          isExpirationEnabled
          expirationDays
          pointsLimitEnabled
          maxPoints
          minPoints
          activitiesChecked
          companyID
          redemptionOptions
          createdAt
          updatedAt
        }
        categoryID
        category {
          id
          name
          type
          companyID
          countryID
          createdAt
          updatedAt
        }
        companyID
        multiplier
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const fidelityProgramCategoriesByCategoryIDAndFidelityProgramID = /* GraphQL */ `
  query FidelityProgramCategoriesByCategoryIDAndFidelityProgramID(
    $categoryID: ID!
    $fidelityProgramID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFidelityProgramCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    fidelityProgramCategoriesByCategoryIDAndFidelityProgramID(
      categoryID: $categoryID
      fidelityProgramID: $fidelityProgramID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fidelityProgramID
        fidelityProgram {
          id
          programName
          monetaryValuePoints
          monetaryValueCurrency
          isExpirationEnabled
          expirationDays
          pointsLimitEnabled
          maxPoints
          minPoints
          activitiesChecked
          companyID
          redemptionOptions
          createdAt
          updatedAt
        }
        categoryID
        category {
          id
          name
          type
          companyID
          countryID
          createdAt
          updatedAt
        }
        companyID
        multiplier
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const fidelityProgramCategoriesByCompanyIDAndFidelityProgramID = /* GraphQL */ `
  query FidelityProgramCategoriesByCompanyIDAndFidelityProgramID(
    $companyID: ID!
    $fidelityProgramID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFidelityProgramCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    fidelityProgramCategoriesByCompanyIDAndFidelityProgramID(
      companyID: $companyID
      fidelityProgramID: $fidelityProgramID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fidelityProgramID
        fidelityProgram {
          id
          programName
          monetaryValuePoints
          monetaryValueCurrency
          isExpirationEnabled
          expirationDays
          pointsLimitEnabled
          maxPoints
          minPoints
          activitiesChecked
          companyID
          redemptionOptions
          createdAt
          updatedAt
        }
        categoryID
        category {
          id
          name
          type
          companyID
          countryID
          createdAt
          updatedAt
        }
        companyID
        multiplier
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFidelityProgramLevel = /* GraphQL */ `
  query GetFidelityProgramLevel($id: ID!) {
    getFidelityProgramLevel(id: $id) {
      id
      fidelityProgramID
      fidelityProgram {
        id
        programName
        monetaryValuePoints
        monetaryValueCurrency
        isExpirationEnabled
        expirationDays
        pointsLimitEnabled
        maxPoints
        minPoints
        activitiesChecked
        companyID
        products {
          nextToken
        }
        categories {
          nextToken
        }
        fidelityLevels {
          nextToken
        }
        redemptionOptions
        createdAt
        updatedAt
      }
      name
      minPoints
      maxPoints
      color
      benefitID
      benefit {
        discountToClients
        discountPercentage
        pointMultiplier
        multiplier
        freeShipping
        specialPromotions
        id
        createdAt
        updatedAt
      }
      companyID
      createdAt
      updatedAt
    }
  }
`;
export const listFidelityProgramLevels = /* GraphQL */ `
  query ListFidelityProgramLevels(
    $filter: ModelFidelityProgramLevelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFidelityProgramLevels(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fidelityProgramID
        fidelityProgram {
          id
          programName
          monetaryValuePoints
          monetaryValueCurrency
          isExpirationEnabled
          expirationDays
          pointsLimitEnabled
          maxPoints
          minPoints
          activitiesChecked
          companyID
          redemptionOptions
          createdAt
          updatedAt
        }
        name
        minPoints
        maxPoints
        color
        benefitID
        benefit {
          discountToClients
          discountPercentage
          pointMultiplier
          multiplier
          freeShipping
          specialPromotions
          id
          createdAt
          updatedAt
        }
        companyID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const fidelityProgramLevelsByFidelityProgramIDAndName = /* GraphQL */ `
  query FidelityProgramLevelsByFidelityProgramIDAndName(
    $fidelityProgramID: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFidelityProgramLevelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    fidelityProgramLevelsByFidelityProgramIDAndName(
      fidelityProgramID: $fidelityProgramID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fidelityProgramID
        fidelityProgram {
          id
          programName
          monetaryValuePoints
          monetaryValueCurrency
          isExpirationEnabled
          expirationDays
          pointsLimitEnabled
          maxPoints
          minPoints
          activitiesChecked
          companyID
          redemptionOptions
          createdAt
          updatedAt
        }
        name
        minPoints
        maxPoints
        color
        benefitID
        benefit {
          discountToClients
          discountPercentage
          pointMultiplier
          multiplier
          freeShipping
          specialPromotions
          id
          createdAt
          updatedAt
        }
        companyID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const fidelityProgramLevelsByCompanyIDAndFidelityProgramID = /* GraphQL */ `
  query FidelityProgramLevelsByCompanyIDAndFidelityProgramID(
    $companyID: ID!
    $fidelityProgramID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFidelityProgramLevelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    fidelityProgramLevelsByCompanyIDAndFidelityProgramID(
      companyID: $companyID
      fidelityProgramID: $fidelityProgramID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fidelityProgramID
        fidelityProgram {
          id
          programName
          monetaryValuePoints
          monetaryValueCurrency
          isExpirationEnabled
          expirationDays
          pointsLimitEnabled
          maxPoints
          minPoints
          activitiesChecked
          companyID
          redemptionOptions
          createdAt
          updatedAt
        }
        name
        minPoints
        maxPoints
        color
        benefitID
        benefit {
          discountToClients
          discountPercentage
          pointMultiplier
          multiplier
          freeShipping
          specialPromotions
          id
          createdAt
          updatedAt
        }
        companyID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFidelityProgramBenefits = /* GraphQL */ `
  query GetFidelityProgramBenefits($id: ID!) {
    getFidelityProgramBenefits(id: $id) {
      discountToClients
      discountPercentage
      pointMultiplier
      multiplier
      freeShipping
      specialPromotions
      id
      createdAt
      updatedAt
    }
  }
`;
export const listFidelityProgramBenefits = /* GraphQL */ `
  query ListFidelityProgramBenefits(
    $filter: ModelFidelityProgramBenefitsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFidelityProgramBenefits(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        discountToClients
        discountPercentage
        pointMultiplier
        multiplier
        freeShipping
        specialPromotions
        id
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const fidelityProgramsByCompanyIDAndStatusProgram = /* GraphQL */ `
  query FidelityProgramsByCompanyIDAndStatusProgram(
    $companyID: ID!
    $statusProgram: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFidelityProgramFilterInput
    $limit: Int
    $nextToken: String
  ) {
    fidelityProgramsByCompanyIDAndStatusProgram(
      companyID: $companyID
      statusProgram: $statusProgram
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        programName
        monetaryValuePoints
        monetaryValueCurrency
        isExpirationEnabled
        expirationDays
        pointsLimitEnabled
        maxPoints
        minPoints
        activitiesChecked
        discountLevels
        pointsPerPurchase
        redeemablePoints
        statusProgram
        companyID
        products {
          items {
            id
            fidelityProgramID
            productID
            companyID
            multiplier
            createdAt
            updatedAt
          }
          nextToken
        }
        categories {
          items {
            id
            fidelityProgramID
            categoryID
            companyID
            multiplier
            createdAt
            updatedAt
          }
          nextToken
        }
        fidelityLevels {
          items {
            id
            fidelityProgramID
            name
            minPoints
            maxPoints
            color
            benefitID
            benefit {
              discountToClients
              discountPercentage
              pointMultiplier
              multiplier
              freeShipping
              specialPromotions
              companyID
              id
              createdAt
              updatedAt
            }
            companyID
            createdAt
            updatedAt
          }
          nextToken
        }
        fidelityProgramCustomer {
          nextToken
        }
        redemptionOptions
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const saleTabsByOrderID = /* GraphQL */ `
  query SaleTabsByOrderID(
    $orderID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSaleTabsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    saleTabsByOrderID(
      orderID: $orderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        locationID
        title
        closable
        orderID
        invoicingData
        shoppingCart
        shoppingCartTran
        shoppingCartSummary
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const receivePaymentRulesByLocationIDAndPaymentMethodID = /* GraphQL */ `
  query ReceivePaymentRulesByLocationIDAndPaymentMethodID(
    $locationID: ID!
    $paymentMethodID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReceivePaymentRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    receivePaymentRulesByLocationIDAndPaymentMethodID(
      locationID: $locationID
      paymentMethodID: $paymentMethodID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        treasuryAccountID
        locationID
        paymentMethodID
      }
      nextToken
    }
  }
`;
